import type { TopicDocMasterportalGfiConfig } from '../../topicDocs/masterportalGfi.types'

const data = {
  barrierAreas: {
    gfiAttributes: {
      natural: {
        name: 'Natürliche Barriere',
        condition: 'contains',
        type: 'string',
        format: {
          water: 'Gewässer',
        },
      },
      aerodrome: {
        name: 'Flugplatztyp',
        condition: 'contains',
        type: 'string',
        format: {
          international: 'Internationaler Flughafen',
          private: 'Privater Flugplatz',
          regional: 'Regionaler Flugplatz',
          gliding: 'Segelflugplatz',
          airsport: 'Luftsportgelände',
        },
      },
      area: {
        name: 'Fläche',
        type: 'number',
      },
      name: 'Name',
    },
  },
  barrierLines: {
    gfiAttributes: {
      highway: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          motorway: 'Autobahn',
          motorway_link: 'Autobahn-Anschluss',
          trunk: 'Kraftfahrstraße',
          trunk_link: 'Kraftfahrstraßen-Anschluss',
        },
      },
      waterway: {
        name: 'Gewässertyp',
        condition: 'contains',
        type: 'string',
        format: {
          river: 'Fluss',
          canal: 'Kanal',
          stream: 'Bach',
          ditch: 'Graben',
          drain: 'Entwässerungsgraben',
        },
      },
      railway: {
        name: 'Schienentyp',
        condition: 'contains',
        type: 'string',
        format: {
          rail: 'Bahnstrecke',
          light_rail: 'Stadtbahn',
          tram: 'Straßenbahn',
          subway: 'U-Bahn',
        },
      },
      usage: {
        name: 'Schienennutzung',
        condition: 'contains',
        type: 'string',
        format: {
          main: 'Hauptstrecke',
          branch: 'Nebenstrecke',
          industrial: 'Industriegleis',
          military: 'Militärisch',
          tourism: 'Touristisch',
          test: 'Teststrecke',
          leisure: 'Freizeitnutzung',
        },
      },
      bridge: {
        name: 'Brücke',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Brücke',
          boardwalk: 'Bohlensteg',
          viaduct: 'Viadukt',
          movable: 'Bewegliche Brücke',
          aqueduct: 'Aquädukt',
          covered: 'Überdachte Brücke',
          cantilever: 'Kragträgerbrücke',
          low_water_crossing: 'Furtenartige Querung',
        },
      },
      tunnel: {
        name: 'Tunnel',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Tunnel',
          culvert: 'Durchlass',
          building_passage: 'Gebäudedurchfahrt',
          flooded: 'Überflutet',
          avalanche_protector: 'Lawinenschutzgalerie',
        },
      },
      name: 'Name',
    },
  },
  bicycleParking_points: {
    gfiAttributes: {
      kind: {
        name: 'Art',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_parking: 'Fahrradstellplätze',
          cargo_bike_parking: 'Lastenrad-Stellplätze',
          small_electric_vehicle_parking: 'E-Scooter- / Kleinstfahrzeug-Parkplätze',
          bicycle_rental: 'Bikesharing-Stationen',
          mobility_hub: 'Mobilitätsstationen',
        },
      },
      capacity: {
        name: 'Anzahl Stellplätze',
        type: 'number',
      },
      access: {
        name: 'Zugang',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Öffentlich',
          customers: 'Kund:innen',
          members: 'Mitglieder',
          permissive: 'Öffentliche Nutzung geduldet',
          private: 'Privat',
          no: 'Kein Zugang',
        },
      },
      covered: {
        name: 'Überdacht',
        condition: 'contains',
        type: 'string',
        format: {
          partial: 'Teilweise überdacht',
          yes: 'Überdacht',
          no: 'Nicht überdacht',
          implicit_no: 'Nicht überdacht (implizit)',
        },
      },
      fee: {
        name: 'Gebühren',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Gebührenpflichtig',
          no: 'Kostenfrei',
          implicit_no: 'Kostenfrei (implizit)',
        },
      },
      access_cargo_bike: {
        name: 'Zugang Lastenrad',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Zugelassen',
          designated: 'Nur Lastenräder',
        },
      },
      lit: {
        name: 'Beleuchtung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Beleuchtet',
          no: 'Nicht beleuchtet',
        },
      },
      stand_type: {
        name: 'Art der Abstellanlage',
        condition: 'contains',
        type: 'string',
        format: {
          stands: 'Anlehnbügel',
          wide_stands: 'Breite Anlehnbügel',
          bollard: 'Poller',
          wall_loops: 'Wandhalter',
          rack: 'Fahrradständer',
          safe_loops: 'Sicherheitsbügel',
          ground_slots: 'Bodenschlitze',
          anchors: 'Bodenanker',
          lean_and_stick: 'Anlehnhilfe',
          handlebar_holder: 'Lenkerhalter',
          upright_stands: 'Vertikalparker',
          'two-tier': 'Doppelstockparker',
          shed: 'Unterstand',
          building: 'Fahrradparkhaus',
          lockers: 'Fahrradboxen',
          streetpod: 'Streetpod',
          smart_dock: 'Smart-Dock',
          floor: 'Abstellfläche ohne Halter',
        },
      },
      rental_type: {
        name: 'Art der Verleihstation',
        condition: 'contains',
        type: 'string',
        format: {
          docking_station: 'Station mit Andockpunkten',
          dropoff_point: 'Abstellfläche (Free-Floating-Zone)',
          key_dispensing_machine: 'Schlüsselautomat',
        },
      },
      network: 'Netz / Verbund',
      in_mobility_hub: {
        name: 'In Mobilitätsstation',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Innerhalb einer Mobilitätsstation',
        },
      },
      geometry_transform: {
        name: 'Geometrie geschätzt',
        condition: 'contains',
        type: 'string',
        format: {
          area_split: 'Fläche nach Stellplätzen geteilt',
          line_halves: 'Linie in der Mitte geteilt',
          point_offset: 'Nebeneinander gesetzt',
        },
      },
      operator_type: {
        name: 'Betreibertyp',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      position: {
        name: 'Lage',
        condition: 'contains',
        type: 'string',
        format: {
          sidewalk: 'Gehweg',
          grass_verge: 'Grünstreifen',
          kerb_extension: 'Gehwegvorstreckung',
          pedestrian_area: 'Fußgängerbereich',
          lane: 'Fahrbahn',
          street_side: 'Straßenrand',
          shoulder: 'Seitenstreifen',
          traffic_island: 'Verkehrsinsel',
          parklet: 'Parklet',
          park: 'Park',
          school_ground: 'Schulgelände',
          playground: 'Spielplatz',
          parking_lot: 'Parkplatz',
          parking: 'Parkfläche',
          driveway: 'Zufahrt',
          private_property: 'Privatgrund',
          public_property: 'Öffentliches Gelände',
        },
      },
      indoor: {
        name: 'Innenraum',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Innen',
        },
      },
      surface: {
        name: 'Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      surveillance: {
        name: 'Überwachung',
        condition: 'contains',
        type: 'string',
        format: {
          outdoor: 'Außenüberwachung',
          public: 'Öffentlich überwacht',
          indoor: 'Innen überwacht',
          yes: 'Überwacht',
          webcam: 'Webcam',
          traffic: 'Verkehrsüberwachung',
          camera: 'Kamera',
          private: 'Privat überwacht',
        },
      },
      count: {
        name: 'Anzahl Anlagen',
        type: 'number',
      },
      name: 'Name',
      operator: 'Betreiber',
      mapillary: {
        name: 'Mapillary',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      description: 'Beschreibung',
      traffic_sign: 'Verkehrszeichen',
      maxstay: 'Maximaldauer',
    },
  },
  bikelanes: {
    gfiAttributes: {
      category: {
        name: 'Bauliche Führung',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
        },
      },
      road: {
        name: 'Straßentyp Fahrbahn',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      parent_road: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      parent_maxspeed: {
        name: 'Höchstgeschwindigkeit der zugeordneten Straße',
        type: 'number',
        suffix: 'km/h',
      },
      adjoining_road: {
        name: 'Straßentyp der angrenzenden Straße',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      adjoining_maxspeed: {
        name: 'Höchstgeschwindigkeit der angrenzenden Straße',
        type: 'number',
        suffix: 'km/h',
      },
      name: 'Name',
      length: {
        name: 'Länge',
        type: 'number',
        suffix: 'm',
      },
      prefix: {
        name: 'Quellpräfix',
        condition: 'contains',
        type: 'string',
        format: {
          cycleway: 'Aus `cycleway:*`-Tags extrahiert',
          sidewalk: 'Aus `sidewalk:*`-Tags extrahiert',
        },
      },
      lifecycle: {
        name: 'Status',
        condition: 'contains',
        type: 'string',
        format: {
          blocked: 'Gesperrt (Sperrung)',
          construction: 'In Bau',
          construction_no_access: 'Gesperrt aufgrund einer Baustelle',
          temporary: 'Temporärer Weg',
        },
      },
      width: {
        name: 'Breite',
        type: 'number',
        suffix: 'm',
      },
      width_effective: {
        name: 'Effektive Breite',
        type: 'number',
        suffix: 'm',
      },
      width_source: {
        name: 'Quelle Breite',
        condition: 'contains',
        type: 'string',
        format: {
          ALKIS: 'Aus ALKIS Daten ausgemessen',
          ARCore: 'Mit dem Handy-Metermaß von StreetComplete gemessen',
        },
      },
      oneway: {
        name: 'Verkehrsrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Eine Richtung',
          no: 'Beide Richtungen',
          car_not_bike: 'Beide Richtungen für Fahrrad; Einbahnstraße für Kfz',
          assumed_no: 'Wahrscheinlich beide Richtungen',
          implicit_yes: 'Eine Richtung (abgeleitet)',
        },
      },
      bridge: {
        name: 'Brücke',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Ja',
        },
      },
      tunnel: {
        name: 'Tunnel',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Ja',
        },
      },
      surface_color: {
        name: 'Ober&shy;flächen&shy;farbe',
        condition: 'contains',
        type: 'string',
        format: {
          red: 'Rot',
          green: 'Grün',
          'red;green': 'Rot und Grün',
          no: 'Keine besondere Farbe',
        },
      },
      separation_left: {
        name: 'Abgrenzung (Links)',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Keine physische Abgrenzung',
          bollard: 'Poller',
          flex_post: 'Flexpfosten',
          vertical_panel: 'Vertikales Panel',
          studs: 'Bodenmarkierungsnägel',
          bump: 'Bodenschwelle',
          planter: 'Pflanzkübel',
          kerb: 'Bordstein',
          fence: 'Zaun',
          jersey_barrier: 'Betonleitwand',
          guard_rail: 'Leitplanke',
          structure: 'Struktur',
          ditch: 'Graben',
          greenery: 'Begrünung',
          hedge: 'Hecke',
          tree_row: 'Baumreihe',
          cone: 'Kegel',
          'kerb;parking_lane': 'Bordstein, dann Parkstreifen',
          'kerb;bollard': 'Bordstein, dann Poller',
          yes: 'Unspezifische Abgrenzung',
        },
      },
      separation_right: {
        name: 'Abgrenzung (Rechts)',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Keine physische Abgrenzung',
          bollard: 'Poller',
          flex_post: 'Flexpfosten',
          vertical_panel: 'Vertikales Panel',
          studs: 'Bodenmarkierungsnägel',
          bump: 'Bodenschwelle',
          planter: 'Pflanzkübel',
          kerb: 'Bordstein',
          fence: 'Zaun',
          jersey_barrier: 'Betonleitwand',
          guard_rail: 'Leitplanke',
          structure: 'Struktur',
          ditch: 'Graben',
          greenery: 'Begrünung',
          hedge: 'Hecke',
          tree_row: 'Baumreihe',
          cone: 'Kegel',
          'kerb;parking_lane': 'Bordstein, dann Parkstreifen',
          'kerb;bollard': 'Bordstein, dann Poller',
          yes: 'Unspezifische Abgrenzung',
        },
      },
      marking_left: {
        name: 'Markierung (Links)',
        condition: 'contains',
        type: 'string',
        format: {
          solid_line: 'Durchgezogene Linie',
          dashed_line: 'Gestrichelte Linie',
          double_solid_line: 'Doppelte durchgezogene Linie',
          barred_area: 'Schraffur',
          pictogram: 'Piktogramm',
          surface: 'Oberfläche',
        },
      },
      marking_right: {
        name: 'Markierung (Rechts)',
        condition: 'contains',
        type: 'string',
        format: {
          solid_line: 'Durchgezogene Linie',
          dashed_line: 'Gestrichelte Linie',
          double_solid_line: 'Doppelte durchgezogene Linie',
          barred_area: 'Schraffur',
          pictogram: 'Piktogramm',
          surface: 'Oberfläche',
        },
      },
      buffer_left: {
        name: 'Schutzraum (Links)',
        type: 'number',
        suffix: 'm',
      },
      buffer_right: {
        name: 'Schutzraum (Rechts)',
        type: 'number',
        suffix: 'm',
      },
      traffic_mode_left: {
        name: 'Verkehrsform (Links)',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle: 'Fahrrad',
          foot: 'Fußgänger',
          motor_vehicle: 'Kraftfahrzeuge',
          no: 'Kein Verkehr',
          parking: 'Parken',
          psv: 'ÖPNV (Bus/Tram)',
        },
      },
      traffic_mode_right: {
        name: 'Verkehrsform (Rechts)',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle: 'Fahrrad',
          foot: 'Fußgänger',
          motor_vehicle: 'Kraftfahrzeuge',
          no: 'Kein Verkehr',
          parking: 'Parken',
          psv: 'ÖPNV (Bus/Tram)',
        },
      },
      mapillary_coverage: {
        name: 'Mapillary-Abdeckung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary: {
        name: 'Straßenfotos (Mapillary)',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_forward: {
        name: 'Mapillary in Linienrichtung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_backward: {
        name: 'Mapillary gegen Linienrichtung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_traffic_sign: {
        name: 'Mapillary für Verkehrszeichen',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      route_relations: 'Routen',
      description: 'Hinweis aus OSM',
      operator_type: {
        name: 'Betreibertyp',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      informal: {
        name: 'Trampelpfad',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Weg als informeller Weg erfasst',
        },
      },
      covered: {
        name: 'Überdacht',
        condition: 'contains',
        type: 'string',
        format: {
          covered: 'Überdacht',
          partial: 'Teilweise überdacht',
          indoor: 'In einem Gebäude',
        },
      },
      lit: {
        name: 'Beleuchtung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Beleuchtet',
          no: 'Nicht beleuchtet',
          special: 'Spezielle Angaben',
        },
      },
      offset: {
        name: 'Linien-Offset',
        type: 'number',
        suffix: 'm',
      },
      surface: {
        name: 'Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      surface_source: {
        name: 'Herkunft der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'Explizite Angabe aus OSM',
          tag_transformed: 'Aus OSM-Tag normalisiert',
          parent_highway_tag: 'Von zugeordneter Straße (OSM)',
          parent_highway_tag_transformed: 'Von zugeordneter Straße, normalisiert',
        },
      },
      surface_confidence: {
        name: 'Konfidenz der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      smoothness: {
        name: 'Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          excellent: 'Sehr gut',
          good: 'Gut',
          intermediate: 'Mittel gut',
          bad: 'Schlecht',
          very_bad: 'Sehr schlecht',
        },
      },
      smoothness_source: {
        name: 'Herkunft der Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'OSM-Tag `smoothness`',
          tag_normalized: 'OSM-Tag `smoothness` (normalisiert)',
          surface_to_smoothness: 'Abgeleitet von `surface`',
          tracktype_to_smoothness: 'Abgeleitet von `tracktype`',
          'mtb:scale_to_smoothness': 'Abgeleitet von `mtb:scale`',
          parent_highway_tag: 'Von zugeordneter Straße (OSM)',
          parent_highway_tag_normalized: 'Von zugeordneter Straße (normalisiert)',
          parent_highway_surface_to_smoothness: 'Von Oberfläche der zugeordneten Straße abgeleitet',
          parent_highway_tracktype_to_smoothness:
            'Von `tracktype` der zugeordneten Straße abgeleitet',
          'parent_highway_mtb:scale_to_smoothness':
            'Von `mtb:scale` der zugeordneten Straße abgeleitet',
        },
      },
      smoothness_confidence: {
        name: 'Konfidenz Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
        },
      },
      traffic_sign: {
        name: 'Beschilderung',
        condition: 'contains',
        type: 'string',
        format: {
          never: 'Kein Verkehrszeichen erwartet',
          none: 'Unbeschildert',
        },
      },
      'traffic_sign:forward': {
        name: 'Beschilderung in Verkehrsrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          never: 'Kein Verkehrszeichen erwartet',
          none: 'Unbeschildert',
        },
      },
      'traffic_sign:backward': {
        name: 'Beschilderung in Gegenrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          never: 'Kein Verkehrszeichen erwartet',
          none: 'Unbeschildert',
        },
      },
      todos: 'Todo-Liste',
    },
  },
  bikelanesPresence: {
    gfiAttributes: {
      bikelane_left: {
        name: 'Radinfrastruktur links',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
          data_no: 'Vollständig (explizit keine)',
          not_expected: 'Keine Infrastruktur erwartet',
          separate_geometry: 'RVA als separate Geometrie erfasst',
          assumed_no: 'Vermutlich vollständig',
          missing: 'Unvollständig',
        },
      },
      bikelane_self: {
        name: 'Radinfrastruktur mittig',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
          data_no: 'Vollständig (explizit keine)',
          not_expected: 'Keine Infrastruktur erwartet',
          separate_geometry: 'RVA als separate Geometrie erfasst',
          assumed_no: 'Vermutlich vollständig',
          missing: 'Unvollständig',
        },
      },
      bikelane_right: {
        name: 'Radinfrastruktur rechts',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
          data_no: 'Vollständig (explizit keine)',
          not_expected: 'Keine Infrastruktur erwartet',
          separate_geometry: 'RVA als separate Geometrie erfasst',
          assumed_no: 'Vermutlich vollständig',
          missing: 'Unvollständig',
        },
      },
    },
  },
  bikeroutes: {
    gfiAttributes: {
      distance: {
        name: 'Angabe Gesamtlänge',
        type: 'number',
        suffix: 'km',
      },
      network: {
        name: 'Netzwerkhierarchie',
        condition: 'contains',
        type: 'string',
        format: {
          lcn: 'Lokale Radverkehrsnetze (`lcn`)',
          rcn: 'Regionale Radverkehrsnetze (`rcn`)',
          ncn: 'Nationales Radverkehrsnetz (`ncn`)',
          icn: 'Internationales Radverkehrsnetz (`icn`)',
        },
      },
      cycle_highway: {
        name: 'Radschnellverbindung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Diese Route repräsentiert eine RSV.',
        },
      },
      roundtrip: {
        name: 'Rundfahrt',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Ja',
          no: 'Nein',
        },
      },
      network_type: {
        name: 'Netzwerkart',
        condition: 'contains',
        type: 'string',
        format: {
          basic_network: 'Start-Ziel Route',
          node_network: 'Teil eines Knotennetzwerks',
        },
      },
      cycle_network_key: 'Netzwerk-Schlüssel',
      symbol_description: 'Symbolbeschreibung',
      route_description: 'Freitext zur Route',
      name: 'Name',
      ref: 'Referenz',
      operator: 'Betreiber/Baulastträger',
      website: 'Website',
      wikipedia: 'Wikipedia',
      colours: 'Farben',
    },
  },
  bikeSuitability: {
    gfiAttributes: {
      bikeSuitability: {
        name: 'Eignung des Weges für Radverkehr, Radnetze und Radrouten',
        condition: 'contains',
        type: 'string',
        format: {
          goodSurface: 'Potentiell geeignet aufgrund einer guten Oberfläche',
          livingStreet: 'Geeignet durch verkehrsberuhigten Bereich',
          noMotorizedVehicle: 'Potentiell geeignet aufgrund des Verbots von Kfz',
          noOvertaking: 'Potentiell geeignet aufgrund Verkehrszeichen 277.1',
        },
      },
      road: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      name: 'Name',
      length: {
        name: 'Länge',
        type: 'number',
        suffix: 'm',
      },
      lifecycle: {
        name: 'Status',
        condition: 'contains',
        type: 'string',
        format: {
          blocked: 'Gesperrt (Sperrung)',
          construction: 'In Bau',
          construction_no_access: 'Gesperrt aufgrund einer Baustelle',
          temporary: 'Temporärer Weg',
        },
      },
      mapillary_coverage: {
        name: 'Mapillary-Abdeckung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary: {
        name: 'Straßenfotos (Mapillary)',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_forward: {
        name: 'Mapillary in Linienrichtung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_backward: {
        name: 'Mapillary gegen Linienrichtung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_traffic_sign: {
        name: 'Mapillary für Verkehrszeichen',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      traffic_sign: {
        name: 'Beschilderung',
        condition: 'contains',
        type: 'string',
        format: {
          none: 'Unbeschildert',
        },
      },
      description: 'Hinweis aus OSM',
      operator_type: {
        name: 'Betreibertyp',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      informal: {
        name: 'Trampelpfad',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Weg als informeller Weg erfasst',
        },
      },
      covered: {
        name: 'Überdacht',
        condition: 'contains',
        type: 'string',
        format: {
          covered: 'Überdacht',
          partial: 'Teilweise überdacht',
          indoor: 'In einem Gebäude',
        },
      },
      surface: {
        name: 'Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      smoothness: {
        name: 'Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          excellent: 'Sehr gut',
          good: 'Gut',
          intermediate: 'Mittel gut',
          bad: 'Schlecht',
          very_bad: 'Sehr schlecht',
        },
      },
    },
  },
  boundaries: {
    gfiAttributes: {
      admin_level: {
        name: 'Grenzen Level',
        type: 'number',
      },
      population: {
        name: 'Bevölkerung',
        type: 'number',
        suffix: 'Einwohner:innen',
      },
      population_date: 'Bevölkerungsstand',
      name: 'Name',
      name_prefix: 'Namenspräfix',
      wikidata: 'Wikidata',
      wikipedia: 'Wikipedia',
      regionalschluessel: 'Regionalschlüssel',
      category_municipality: 'Gemeindekategorie',
      category_district: 'Kreiskategorie',
    },
  },
  busroutes: {
    gfiAttributes: {
      route: 'Routentyp (`route=*`)',
      name: 'Name',
      ref: 'Referenz',
      network: 'Netz (`network=*`)',
      operator: 'Betreiber',
      from: 'Start',
      to: 'Ziel',
      route_description: 'Freitext zur Route',
      colours: 'Farben (mit `/` getrennt)',
      website: 'Website',
      wikipedia: 'Wikipedia',
    },
  },
  footroutes: {
    gfiAttributes: {
      route: 'Routentyp (`route=*`)',
      name: 'Name',
      ref: 'Referenz',
      network: 'Netz (`network=*`)',
      operator: 'Betreiber',
      from: 'Start',
      to: 'Ziel',
      route_description: 'Freitext zur Route',
      colours: 'Farben (mit `/` getrennt)',
      website: 'Website',
      wikipedia: 'Wikipedia',
    },
  },
  highwayAreas: {
    gfiAttributes: {
      road: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      name: 'Name',
      area: {
        name: 'Fläche',
        type: 'number',
        suffix: 'm²',
      },
      lifecycle: {
        name: 'Status',
        condition: 'contains',
        type: 'string',
        format: {
          blocked: 'Gesperrt (Sperrung)',
          construction: 'In Bau',
          construction_no_access: 'Gesperrt aufgrund einer Baustelle',
          temporary: 'Temporärer Weg',
        },
      },
      oneway: {
        name: 'Verkehrsrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Beide Richtungen',
          yes: 'Einbahnstraße',
          yes_dual_carriageway: 'Einbahnstraße da separate Geometrie pro Seite',
        },
      },
      oneway_bicycle: {
        name: 'Verkehrsrichtung Fahrrad',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Beide Richtungen für Radverkehr',
          yes: 'Eine Richtung (auch für Radverkehr)',
        },
      },
      mapillary_coverage: {
        name: 'Mapillary-Abdeckung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary: {
        name: 'Straßenfotos (Mapillary)',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_forward: {
        name: 'Mapillary in Linienrichtung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_backward: {
        name: 'Mapillary gegen Linienrichtung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_traffic_sign: {
        name: 'Mapillary für Verkehrszeichen',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      traffic_sign: {
        name: 'Beschilderung',
        condition: 'contains',
        type: 'string',
        format: {
          none: 'Unbeschildert',
        },
      },
      description: 'Hinweis aus OSM',
      operator_type: {
        name: 'Betreibertyp',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      informal: {
        name: 'Trampelpfad',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Weg als informeller Weg erfasst',
        },
      },
      covered: {
        name: 'Überdacht',
        condition: 'contains',
        type: 'string',
        format: {
          covered: 'Überdacht',
          partial: 'Teilweise überdacht',
          indoor: 'In einem Gebäude',
        },
      },
      lit: {
        name: 'Beleuchtung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Beleuchtet',
          no: 'Nicht beleuchtet',
          special: 'Spezielle Angaben',
        },
      },
      width: {
        name: 'Breite',
        type: 'number',
        suffix: 'm',
      },
      width_source: {
        name: 'Quelle Breite',
        condition: 'contains',
        type: 'string',
        format: {
          ALKIS: 'Aus ALKIS Daten ausgemessen',
          ARCore: 'Mit dem Handy-Metermaß von StreetComplete gemessen',
        },
      },
      bridge: {
        name: 'Brücke',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Ja',
        },
      },
      tunnel: {
        name: 'Tunnel',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Ja',
        },
      },
      surface: {
        name: 'Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      surface_source: {
        name: 'Herkunft der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'Explizite Angabe aus OSM',
          tag_transformed: 'Aus OSM-Tag normalisiert',
          parent_highway_tag: 'Von zugeordneter Straße (OSM)',
          parent_highway_tag_transformed: 'Von zugeordneter Straße, normalisiert',
        },
      },
      surface_confidence: {
        name: 'Konfidenz der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      smoothness: {
        name: 'Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          excellent: 'Sehr gut',
          good: 'Gut',
          intermediate: 'Mittel gut',
          bad: 'Schlecht',
          very_bad: 'Sehr schlecht',
        },
      },
      smoothness_source: {
        name: 'Herkunft der Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'OSM-Tag `smoothness`',
          tag_normalized: 'OSM-Tag `smoothness` (normalisiert)',
          surface_to_smoothness: 'Abgeleitet von `surface`',
          tracktype_to_smoothness: 'Abgeleitet von `tracktype`',
          'mtb:scale_to_smoothness': 'Abgeleitet von `mtb:scale`',
        },
      },
      smoothness_confidence: {
        name: 'Konfidenz Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
        },
      },
    },
  },
  hikingroutes: {
    gfiAttributes: {
      route: 'Routentyp (`route=*`)',
      name: 'Name',
      ref: 'Referenz',
      network: 'Netz (`network=*`)',
      operator: 'Betreiber',
      from: 'Start',
      to: 'Ziel',
      route_description: 'Freitext zur Route',
      colours: 'Farben (mit `/` getrennt)',
      website: 'Website',
      wikipedia: 'Wikipedia',
    },
  },
  landuse: {
    gfiAttributes: {
      landuse: {
        name: 'Landnutzung',
        condition: 'contains',
        type: 'string',
        format: {
          allotments: 'Kleingartenanlage',
          brownfield: 'Brachfläche',
          cemetery: 'Friedhofsgelände',
          civic: 'Fläche für öffentliche Einrichtungen',
          civic_admin: 'Verwaltungsfläche',
          commercial: 'Gewerbliche Nutzung',
          construction: 'Baufläche (im Bau)',
          education: 'Bildungsfläche',
          farmyard: 'Landwirtschaftliche Nutzung',
          garages: 'Garagen',
          industrial: 'Industrielle Nutzung',
          religious: 'Religiöse Nutzung',
          residential: 'Wohngebiet',
          retail: 'Gewerbliche Nutzung (Einzelhandel/Geschäfte)',
          school: 'Schulgelände',
          university: 'Universitätsgelände',
          kindergarten: 'Kindertagesstätte',
          college: 'Hochschul-/College-Gelände',
          hospital: 'Krankenhausgelände',
          clinic: 'Klinikgelände',
          prison: 'Justizvollzugsanstalt',
          park: 'Park',
          garden: 'Garten',
          dog_park: 'Hundeauslaufgebiet',
          sports_centre: 'Sportzentrum',
          stadium: 'Stadion',
        },
      },
      access: {
        name: 'Zugang',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Öffentlich',
          customers: 'Kund:innen',
          permissive: 'Öffentliche Nutzung geduldet',
          private: 'Privat',
          public: 'Öffentlich (explizit)',
          no: 'Kein Zugang',
        },
      },
      name: 'Name',
      operator: 'Betreiber',
    },
  },
  mtbroutes: {
    gfiAttributes: {
      route: 'Routentyp (`route=*`)',
      name: 'Name',
      ref: 'Referenz',
      network: 'Netz (`network=*`)',
      operator: 'Betreiber',
      from: 'Start',
      to: 'Ziel',
      route_description: 'Freitext zur Route',
      colours: 'Farben (mit `/` getrennt)',
      website: 'Website',
      wikipedia: 'Wikipedia',
    },
  },
  off_street_parking_areas: {
    gfiAttributes: {
      category: {
        name: 'Kategorie',
        condition: 'contains',
        type: 'string',
        format: {
          outside: 'Außenparkplatz',
          garage: 'Garage',
          underground: 'Tiefgarage',
          carport: 'Carport',
          'multi-storey': 'Parkhaus',
        },
      },
      parking: {
        name: 'Parkplatztyp',
        condition: 'contains',
        type: 'string',
        format: {
          surface: 'Oberflächenparkplatz',
          underground: 'Tiefgarage',
          'multi-storey': 'Parkhaus',
          rooftop: 'Dachparkplatz',
          carport: 'Carport',
          carports: 'Carports',
          garage_boxes: 'Garagenboxen',
          garage: 'Garage',
        },
      },
      amenity: {
        name: 'Einrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          parking: 'Parkplatz',
        },
      },
      capacity: {
        name: 'Stellplatzanzahl',
        type: 'number',
      },
      capacity_source: {
        name: 'Herkunft der Stellplatzanzahl',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'Explizite Angabe aus OSM.',
          tag_estimation: 'Explizite Angabe einer Schätzung aus OSM.',
          tag_redistributed: 'Explizite Angabe aus OSM, dann anteilig aufgeteilt nach Stanzung.',
          tag_estimation_redistributed:
            'Explizite Angabe einer Schätzung aus OSM, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_parallel: 'Berechnet auf Basis der Fläche und Parkausrichtung.',
          area_and_orientation_perpendicular: 'Berechnet auf Basis der Fläche und Parkausrichtung.',
          area_and_orientation_diagonal: 'Berechnet auf Basis der Fläche und Parkausrichtung.',
          area_and_orientation_parallel_redistributed:
            'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_perpendicular_redistributed:
            'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_diagonal_redistributed:
            'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_fallback_parallel:
            'Berechnet auf Basis der Fläche und Parkausrichtung. Allerdings war die Parkausrichtung unbekannt, so dass Parallelparken angenommen wurde.',
          estimated_from_length: 'Berechnet auf Basis der Linien-Länge und Ausrichtung.',
          estimated_from_area: 'Berechnet auf Basis der Fläche und Ausrichtung.',
          estimated: 'Berechnung',
          estimated_redistributed: 'Geschätzt, Kapazität umverteilt',
          assumed_default: 'Keine explizite Angabe vorgefunden; dieser Wert ist eine Annahme.',
          area: 'Berechnet auf Basis der Fläche.',
        },
      },
      condition_category: {
        name: 'Parkbeschränkung',
        condition: 'contains',
        type: 'string',
        format: {
          access_restriction: 'Zugangsbeschränkung',
          assumed_free: 'Wahrscheinlich keine Parkbeschränkungen',
          assumed_private: 'Sehr wahrscheinlich privat',
          bus_lane: 'Bussonderfahrstreifen',
          car_sharing: 'Nur für Carsharing-Fahrzeuge',
          charging: 'Laden von Elektrofahrzeugen',
          disabled: 'Behindertenparkplatz',
          disabled_private: 'Personenbezogener Behindertenparkplatz',
          free: 'Keine Parkbeschränkungen',
          invalid: 'Ungültige Angabe in OSM',
          loading: 'Ladezone',
          maxweight: 'Gewichtsbegrenzung',
          mixed: 'Nur mit Parkschein oder Bewohnerparkausweis',
          no_parking: 'Eingeschränktes Haltverbot',
          no_standing: 'Nur kurzes Halten erlaubt',
          no_stopping: 'Absolutes Haltverbot',
          paid: 'Nur mit Parkschein',
          private: 'Privat',
          residents: 'Nur mit Bewohnerparkausweis',
          taxi: 'Taxenstand',
          time_limited: 'Höchstparkdauer',
          unspecified: 'Unbestimmt',
          vehicle_restriction: 'Beschränkung auf Fahrzeugklassen',
        },
      },
      condition_category_primary: {
        name: 'Primäre Parkbeschränkung',
        condition: 'contains',
        type: 'string',
        format: {
          access_restriction: 'Zugangsbeschränkung',
          assumed_free: 'Wahrscheinlich keine Parkbeschränkungen',
          assumed_private: 'Sehr wahrscheinlich privat',
          bus_lane: 'Bussonderfahrstreifen',
          car_sharing: 'Nur für Carsharing-Fahrzeuge',
          charging: 'Laden von Elektrofahrzeugen',
          disabled: 'Behindertenparkplatz',
          disabled_private: 'Personenbezogener Behindertenparkplatz',
          free: 'Keine Parkbeschränkungen',
          invalid: 'Ungültige Angabe in OSM',
          loading: 'Ladezone',
          maxweight: 'Gewichtsbegrenzung',
          mixed: 'Nur mit Parkschein oder Bewohnerparkausweis',
          no_parking: 'Eingeschränktes Haltverbot',
          no_standing: 'Nur kurzes Halten erlaubt',
          no_stopping: 'Absolutes Haltverbot',
          paid: 'Nur mit Parkschein',
          private: 'Privat',
          residents: 'Nur mit Bewohnerparkausweis',
          taxi: 'Taxenstand',
          time_limited: 'Höchstparkdauer',
          unspecified: 'Unbestimmt',
          vehicle_restriction: 'Beschränkung auf Fahrzeugklassen',
          default: 'Keine Zuordnung',
        },
      },
      access: {
        name: 'Zugang',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          customers: 'Kund:innen',
          destination: 'Anlieger frei (Nicht-Durchgangsverkehr erlaubt)',
          employees: 'Mitarbeiter',
          permissive: 'Öffentliche Nutzung geduldet',
          public: 'Öffentlich (explizit)',
          delivery: 'Lieferverkehr',
          no: 'Kein Zugang',
          permit: 'Mit Genehmigung',
          residents: 'Nur mit Bewohnerparkausweis',
        },
      },
      area: {
        name: 'Fläche',
        type: 'number',
        suffix: 'm²',
      },
      area_source: {
        name: 'Herkunft der Flächenangabe',
        condition: 'contains',
        type: 'string',
        format: {
          estimated: 'Berechnet auf Basis der Länge der Liniengeometrie und Fahrzeugausrichtung.',
          geometry: 'Basiert auf dem Flächeninhalt der Geometrie aus OSM.',
        },
      },
      area_confidence: {
        name: 'Konfidenz der Flächenangabe',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      capacity_confidence: {
        name: 'Konfidenz der Stellplatzanzahl',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      surface: {
        name: 'Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      surface_confidence: {
        name: 'Konfidenz der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      surface_source: {
        name: 'Herkunft der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'Explizite Angabe aus OSM',
          tag_transformed: 'Aus OSM-Tag normalisiert',
          parent_highway_tag: 'Von zugeordneter Straße (OSM)',
          parent_highway_tag_transformed: 'Von zugeordneter Straße, normalisiert',
        },
      },
      orientation: {
        name: 'Ausrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          parallel: 'Parallelparken',
          perpendicular: 'Querparken',
          diagonal: 'Schrägparken',
        },
      },
      location: {
        name: 'Lage im Straßenraum',
        condition: 'contains',
        type: 'string',
        format: {
          lane_centre: 'Fahrbahnmitte',
          median: 'Mittelstreifen',
        },
      },
      markings: {
        name: 'Markierungen',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Ohne Markierungen',
          yes: 'Mit Markierungen',
        },
      },
      covered: {
        name: 'Überdacht',
        condition: 'contains',
        type: 'string',
        format: {
          partial: 'Teilweise überdacht',
          yes: 'Überdacht',
        },
      },
      informal: {
        name: 'Duldung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Parken im rechtlichen Graubereich oder etabliertes, geduldetes Falschparken.',
        },
      },
      operator_type: {
        name: 'Betreibertyp',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      operator_type_source: {
        name: 'Herkunft des Betreibertyps',
        condition: 'contains',
        type: 'string',
        format: {
          default_fallback: 'Annahme bei fehlender Angabe.',
          driveway_inference: 'Annahme bei fehlender Angabe wenn eine Einfahrt erkannt wurde.',
          manual_overwrite_list: 'Anhand einer manuellen Korrekturliste in TILDA.',
          parent_highway_tag: 'Explizite Angabe aus OSM an der zugeordneten Straße.',
          tag: 'Explizite Angabe aus OSM.',
        },
      },
      operator_type_confidence: {
        name: 'Konfidenz des Betreibertyps',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      zone: 'Parkzone',
      mapillary: {
        name: 'Mapillary',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      traffic_sign: 'Verkehrszeichen',
    },
  },
  parkings: {
    gfiAttributes: {
      parking: {
        name: 'Parkposition',
        condition: 'contains',
        type: 'string',
        format: {
          lane: 'Auf der Fahrbahn',
          half_on_kerb: 'Halb auf dem Gehweg',
          on_kerb: 'Ganz auf dem Gehweg',
          no_parking: 'Eingeschränktes Haltverbot',
          no_stopping: 'Absolutes Haltverbot',
          separate: 'Parkraum als separate Geometrie erfasst',
          shoulder: 'Auf dem Seitenstreifen',
          street_side: 'Parkbucht',
          yes: 'Nicht näher bestimmtes Straßenparken',
          no: 'Kein Parken (Sonstiger/Unbekannter Grund)',
          no_standing: 'Nur kurzes Halten erlaubt',
          missing: 'Daten in OSM fehlen',
          not_expected: 'Kein Parken zu erwarten',
        },
      },
      capacity: {
        name: 'Stellplatzanzahl',
        type: 'number',
      },
      capacity_source: {
        name: 'Herkunft der Stellplatzanzahl',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'Explizite Angabe aus OSM.',
          tag_estimation: 'Explizite Angabe einer Schätzung aus OSM.',
          tag_redistributed: 'Explizite Angabe aus OSM, dann anteilig aufgeteilt nach Stanzung.',
          tag_estimation_redistributed:
            'Explizite Angabe einer Schätzung aus OSM, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_parallel: 'Berechnet auf Basis der Fläche und Parkausrichtung.',
          area_and_orientation_perpendicular: 'Berechnet auf Basis der Fläche und Parkausrichtung.',
          area_and_orientation_diagonal: 'Berechnet auf Basis der Fläche und Parkausrichtung.',
          area_and_orientation_parallel_redistributed:
            'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_perpendicular_redistributed:
            'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_diagonal_redistributed:
            'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_fallback_parallel:
            'Berechnet auf Basis der Fläche und Parkausrichtung. Allerdings war die Parkausrichtung unbekannt, so dass Parallelparken angenommen wurde.',
          estimated_from_length: 'Berechnet auf Basis der Linien-Länge und Ausrichtung.',
          estimated_from_area: 'Berechnet auf Basis der Fläche und Ausrichtung.',
          estimated: 'Berechnung',
          estimated_redistributed: 'Geschätzt, Kapazität umverteilt',
          assumed_default: 'Keine explizite Angabe vorgefunden; dieser Wert ist eine Annahme.',
        },
      },
      orientation: {
        name: 'Ausrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          parallel: 'Parallelparken',
          perpendicular: 'Querparken',
          diagonal: 'Schrägparken',
        },
      },
      condition_category: {
        name: 'Parkbeschränkung',
        condition: 'contains',
        type: 'string',
        format: {
          access_restriction: 'Zugangsbeschränkung',
          assumed_free: 'Wahrscheinlich keine Parkbeschränkungen',
          assumed_private: 'Sehr wahrscheinlich privat',
          bus_lane: 'Bussonderfahrstreifen',
          car_sharing: 'Nur für Carsharing-Fahrzeuge',
          charging: 'Laden von Elektrofahrzeugen',
          disabled: 'Behindertenparkplatz',
          disabled_private: 'Personenbezogener Behindertenparkplatz',
          free: 'Keine Parkbeschränkungen',
          invalid: 'Ungültige Angabe in OSM',
          loading: 'Ladezone',
          maxweight: 'Gewichtsbegrenzung',
          mixed: 'Nur mit Parkschein oder Bewohnerparkausweis',
          no_parking: 'Eingeschränktes Haltverbot',
          no_standing: 'Nur kurzes Halten erlaubt',
          no_stopping: 'Absolutes Haltverbot',
          paid: 'Nur mit Parkschein',
          private: 'Privat',
          residents: 'Nur mit Bewohnerparkausweis',
          taxi: 'Taxenstand',
          time_limited: 'Höchstparkdauer',
          unspecified: 'Unbestimmt',
          vehicle_restriction: 'Beschränkung auf Fahrzeugklassen',
        },
      },
      condition_category_primary: {
        name: 'Primäre Parkbeschränkung',
        condition: 'contains',
        type: 'string',
        format: {
          access_restriction: 'Zugangsbeschränkung',
          assumed_free: 'Wahrscheinlich keine Parkbeschränkungen',
          assumed_private: 'Sehr wahrscheinlich privat',
          bus_lane: 'Bussonderfahrstreifen',
          car_sharing: 'Nur für Carsharing-Fahrzeuge',
          charging: 'Laden von Elektrofahrzeugen',
          disabled: 'Behindertenparkplatz',
          disabled_private: 'Personenbezogener Behindertenparkplatz',
          free: 'Keine Parkbeschränkungen',
          invalid: 'Ungültige Angabe in OSM',
          loading: 'Ladezone',
          maxweight: 'Gewichtsbegrenzung',
          mixed: 'Nur mit Parkschein oder Bewohnerparkausweis',
          no_parking: 'Eingeschränktes Haltverbot',
          no_standing: 'Nur kurzes Halten erlaubt',
          no_stopping: 'Absolutes Haltverbot',
          paid: 'Nur mit Parkschein',
          private: 'Privat',
          residents: 'Nur mit Bewohnerparkausweis',
          taxi: 'Taxenstand',
          time_limited: 'Höchstparkdauer',
          unspecified: 'Unbestimmt',
          vehicle_restriction: 'Beschränkung auf Fahrzeugklassen',
          default: 'Keine Zuordnung',
        },
      },
      staggered: {
        name: 'Parkweise',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Alternierendes Parken',
          no: 'Nicht alternierend',
        },
      },
      length: {
        name: 'Länge',
        type: 'number',
        suffix: 'm',
      },
      category: {
        name: 'Kategorie',
        condition: 'contains',
        type: 'string',
        format: {
          bus_stop: 'Bushaltestelle',
          tree: 'Baum',
          crossing_marked: 'Markierter Überweg',
        },
      },
      source: {
        name: 'Datenquelle',
        condition: 'contains',
        type: 'string',
        format: {
          parkings: 'Angaben an der Straßenlinie',
          separate_parking_areas: 'Separat erfasste Flächendaten',
          separate_parking_points: 'Separate erfasste Punktdaten',
        },
      },
      geom_sources: '(Intern) OSM-IDs der Geometrien',
      tag_sources: 'Tag-Quellen',
      road: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      road_name: 'Straßenname',
      road_oneway: {
        name: 'Einbahnstraße',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Nein (in beide Richtungen befahrbar)',
          yes: 'Einbahnstraße',
          yes_dual_carriageway: 'Einbahnstraße (getrennte Richtungsfahrbahnen)',
        },
      },
      road_width: {
        name: 'Fahrbahnbreite',
        type: 'number',
        suffix: 'm',
      },
      road_width_source: {
        name: 'Herkunft der Fahrbahnbreite',
        condition: 'contains',
        type: 'string',
        format: {
          highway_default: 'Standard-Wert für diesen Straßentyp.',
          highway_default_and_oneway: 'Standard-Wert für diesen Straßentyp als Einbahnstraße.',
          tag: 'Dieser Wert ist in OSM hinterlegt.',
        },
      },
      road_width_confidence: {
        name: 'Konfidenz der Fahrbahnbreite',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      side: {
        name: 'Straßenseite',
        condition: 'contains',
        type: 'string',
        format: {
          left: 'Links',
          right: 'Rechts',
        },
      },
      area: {
        name: 'Fläche',
        type: 'number',
        suffix: 'm²',
      },
      area_source: {
        name: 'Herkunft der Flächenangabe',
        condition: 'contains',
        type: 'string',
        format: {
          estimated: 'Berechnet auf Basis der Länge der Liniengeometrie und Fahrzeugausrichtung.',
          geometry: 'Basiert auf dem Flächeninhalt der Geometrie aus OSM.',
        },
      },
      area_confidence: {
        name: 'Konfidenz der Flächenangabe',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      capacity_confidence: {
        name: 'Konfidenz der Stellplatzanzahl',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      surface: {
        name: 'Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      surface_confidence: {
        name: 'Konfidenz der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      surface_source: {
        name: 'Herkunft der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'Explizite Angabe aus OSM',
          tag_transformed: 'Aus OSM-Tag normalisiert',
          parent_highway_tag: 'Von zugeordneter Straße (OSM)',
          parent_highway_tag_transformed: 'Von zugeordneter Straße, normalisiert',
        },
      },
      direction: {
        name: 'Einparkrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          back_in: 'Rückwärts einparken',
          head_in: 'Vorwärts einparken',
        },
      },
      location: {
        name: 'Lage im Straßenraum',
        condition: 'contains',
        type: 'string',
        format: {
          lane_centre: 'Fahrbahnmitte',
          median: 'Mittelstreifen',
        },
      },
      markings: {
        name: 'Markierungen',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Ohne Markierungen',
          yes: 'Mit Markierungen',
        },
      },
      covered: {
        name: 'Überdacht',
        condition: 'contains',
        type: 'string',
        format: {
          partial: 'Teilweise überdacht',
          yes: 'Überdacht',
        },
      },
      access: {
        name: 'Zugang',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          customers: 'Kund:innen',
          destination: 'Anlieger frei (Nicht-Durchgangsverkehr erlaubt)',
          employees: 'Mitarbeiter',
          permissive: 'Öffentliche Nutzung geduldet',
          public: 'Öffentlich (explizit)',
          delivery: 'Lieferverkehr',
          no: 'Kein Zugang',
          permit: 'Mit Genehmigung',
          residents: 'Nur mit Bewohnerparkausweis',
        },
      },
      operator_type: {
        name: 'Betreibertyp',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      operator_type_source: {
        name: 'Herkunft des Betreibertyps',
        condition: 'contains',
        type: 'string',
        format: {
          default_fallback: 'Annahme bei fehlender Angabe.',
          driveway_inference: 'Annahme bei fehlender Angabe wenn eine Einfahrt erkannt wurde.',
          manual_overwrite_list: 'Anhand einer manuellen Korrekturliste in TILDA.',
          parent_highway_tag: 'Explizite Angabe aus OSM an der zugeordneten Straße.',
          tag: 'Explizite Angabe aus OSM.',
        },
      },
      operator_type_confidence: {
        name: 'Konfidenz des Betreibertyps',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      informal: {
        name: 'Duldung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Parken im rechtlichen Graubereich oder etabliertes, geduldetes Falschparken.',
        },
      },
      zone: 'Parkzone',
      reason: {
        name: 'Grund',
        condition: 'contains',
        type: 'string',
        format: {
          missing_data: 'Keine Parkraum-Daten in OpenStreetMap erfasst',
          parking_tag: 'Explizite Angabe in den Daten',
          restriction_no_parking: 'Explizites Parkverbot aus OSM',
          restriction_no_stopping: 'Explizites Halteverbot aus OSM',
          restriction_no_standing: 'Eingeschränktes Halteverbot aus OSM',
          bus_stop: 'Haltestelle',
          cycleway: 'Radverkehrsanlage',
          dual_carriage: 'Getrennte Richtungsfahrbahnen',
          junction: 'Knotenpunkt / Einmündung',
          narrow: 'Zu schmale Fahrbahn',
        },
      },
      mapillary: {
        name: 'Mapillary',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      traffic_sign: 'Verkehrszeichen',
      _staggered_maneuvering_loss: {
        name: '(Intern) Manövrierraumverlust (alternierendes Parken)',
        type: 'number',
      },
      _staggered_original_capacity: {
        name: '(Intern) Ursprüngliche Kapazität (vor Staggered-Anpassung)',
        type: 'number',
      },
    },
  },
  parkings_cutouts: {
    gfiAttributes: {
      category: {
        name: 'Stanzungen',
        condition: 'contains',
        type: 'string',
        format: {
          advertising: 'Werbeträger',
          barrier: 'Barriere',
          bicycle_parking: 'Fahrradparkplatz',
          bicycle_rental: 'Fahrradverleih',
          bollard: 'Poller',
          bus_stop: 'Bushaltestelle',
          bus_stop_conditional:
            'Bushaltestelle mit zeitlichen Einschränkungen (Nachtbusse, Schulbusse)',
          bus_stop_centerline: 'Bushaltestelle (Mittellinie)',
          bus_stop_kerb: 'Bushaltestelle (Bordstein)',
          collision_protection: 'Baumschutzbügel',
          crossing_buffer_marking: 'Markierung (Sperrfläche u.ä.) an Querungsstelle',
          crossing_kerb_extension: 'Gehwegvorstreckung an Querungsstelle',
          crossing_continuous: 'Durchgängige Querung',
          crossing_marked: 'Markierte Querungsstelle',
          crossing_traffic_signals: 'Ampelquerung',
          crossing_zebra: 'Fußgängerüberweg (Zebrastreifen)',
          driveway: 'Einfahrt',
          driveway_corner_kerb: 'Implizites Halteverbot am Beginn einer Einfahrt',
          fire_hydrant: 'Hydrant',
          intersection_corner: 'Implizites Halteverbot an Straßenecke',
          kerb_lowered: 'Abgesenkter Bordstein',
          kerb_extension: 'Gehwegvorstreckung',
          loading_ramp: 'Transportüberweg',
          mobility_hub: 'Mobilitätsstation',
          motorcycle_parking: 'Motorradparkplatz',
          other: 'Sonstiges Hindernis',
          parklet: 'Parklet',
          recycling: 'Recyclingstation',
          road_marking_restricted_area: 'Sperrfläche (Markierung)',
          small_electric_vehicle_parking: 'Abstellfläche für Elektrokleinstfahrzeuge',
          street_cabinet: 'Schaltkasten, Straßenkasten, u.ä.',
          street_lamp: 'Straßenlaterne',
          traffic_calming_choker: 'Angelegte Fahrbahnverengung',
          traffic_sign: 'Verkehrszeichen',
          tram_stop: 'Straßenbahnhaltestelle',
          tree: 'Baum',
          tree_pit: 'Baumscheibe',
          vending_parking_tickets: 'Parkscheinautomat',
          water_well: 'Straßenbrunnen / Wasserstelle',
        },
      },
      source: {
        name: 'Datenquelle',
        condition: 'contains',
        type: 'string',
        format: {
          crossing: 'Überwege',
          driveway_corner_kerbs: 'Implizites Halteverbot am Beginn einer Einfahrt',
          driveways: 'Einfahrten',
          external_cutouts_euvm: 'Externe Hindernisdaten (eUVM)',
          intersections: 'Kreuzungen',
          obstacle_areas: 'Flächige Hindernisse',
          obstacle_lines: 'Linienhafte Hindernisse',
          obstacle_points: 'Punktuelle Hindernisse',
          public_transport_stops: 'ÖPNV-Haltestellen',
          separate_parking_areas: 'Parkplätze die separat als Fläche erfasst sind',
          separate_parking_points: 'Parkplätze die separat als Punkt erfasst sind',
        },
      },
      buffer_radius: {
        name: 'Radius der Stanzung',
        type: 'number',
        suffix: 'm',
      },
      radius: {
        name: 'Pufferradius',
        type: 'number',
        suffix: 'm',
      },
      side: {
        name: 'Seite relativ zur Fahrbahn',
        condition: 'contains',
        type: 'string',
        format: {
          left: 'Links',
          right: 'Rechts',
          platform: 'Bahnsteig / ohne Kerb-Seite',
        },
      },
      width: {
        name: 'Breite',
        type: 'number',
        suffix: 'm',
      },
      no_cutout_for_restrictions: {
        name: 'Gilt nicht bei Park-/Halteverbot entlang der Linie',
        condition: 'contains',
        type: 'string',
        format: {
          true: 'Ja (Stanzung wird bei echten Verbotssegmenten nicht angewendet)',
        },
      },
      road: 'Fahrbahn-Referenz (Einfahrt)',
      'street:name': 'Straßenname (Einfahrt)',
      amenity: 'OSM-Kategorie "amenity"',
      barrier: 'OSM-Kategorie "barrier"',
      capacity: {
        name: 'Kapazität (OSM / Zwischenwert)',
        type: 'number',
      },
      'capacity:cargo_bike': {
        name: 'Kapazität Lastenrad (OSM)',
        type: 'number',
      },
      direction: 'Richtung (OSM)',
      emergency: 'OSM-Kategorie "emergency"',
      geom_sources: 'Geometrie-Quellen',
      geometry_source: 'Geometrieherkunft',
      kerb: 'Bordstein (OSM-Kategorie "kerb")',
      landuse: 'Flächennutzung (OSM-Kategorie "landuse")',
      man_made: 'Künstliche Objekte (OSM-Kategorie "man_made")',
      name: 'Name (OSM)',
      natural: 'Natur (OSM-Kategorie "natural")',
      operator: 'Betreiber (OSM)',
      ref: 'Referenz (OSM-Kategorie "ref")',
      separate_parking: 'Separater Parkplatz (OSM-Bezug)',
      tag_sources: 'Tag-Quellen',
      traffic_calming: 'Verkehrsberuhigung (OSM-Kategorie "traffic_calming")',
    },
  },
  parkings_edges: {
    gfiAttributes: {
      name: 'Straßenname',
      highway: {
        name: 'OSM-Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          cycleway: 'Radweg',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway: 'Autobahn',
          motorway_link: 'Zufahrt einer Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          road: 'Unkategorisierte Straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          service: 'Zufahrtsweg',
          steps: 'Stufen',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          trunk: 'Kraftfahrstraße',
          trunk_link: 'Kraftfahrstraßen-Anschluss',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          construction: 'Straße ist in Bau',
        },
      },
      road: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      capacity_left: {
        name: 'Öffentliche Stellplätze links',
        type: 'number',
      },
      capacity_right: {
        name: 'Öffentliche Stellplätze rechts',
        type: 'number',
      },
      capacity_private_left: {
        name: 'Private Stellplätze links',
        type: 'number',
      },
      capacity_private_right: {
        name: 'Private Stellplätze rechts',
        type: 'number',
      },
      operator_type_left: {
        name: 'Operator links',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      operator_type_right: {
        name: 'Operator rechts',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      condition_category_left: {
        name: 'Parkbeschränkung links',
        condition: 'contains',
        type: 'string',
        format: {
          access_restriction: 'Zugangsbeschränkung',
          assumed_free: 'Wahrscheinlich keine Parkbeschränkungen',
          assumed_private: 'Sehr wahrscheinlich privat',
          bus_lane: 'Bussonderfahrstreifen',
          car_sharing: 'Nur für Carsharing-Fahrzeuge',
          charging: 'Laden von Elektrofahrzeugen',
          disabled: 'Behindertenparkplatz',
          disabled_private: 'Personenbezogener Behindertenparkplatz',
          free: 'Keine Parkbeschränkungen',
          invalid: 'Ungültige Angabe in OSM',
          loading: 'Ladezone',
          maxweight: 'Gewichtsbegrenzung',
          mixed: 'Nur mit Parkschein oder Bewohnerparkausweis',
          no_parking: 'Eingeschränktes Haltverbot',
          no_standing: 'Nur kurzes Halten erlaubt',
          no_stopping: 'Absolutes Haltverbot',
          paid: 'Nur mit Parkschein',
          private: 'Privat',
          residents: 'Nur mit Bewohnerparkausweis',
          taxi: 'Taxenstand',
          time_limited: 'Höchstparkdauer',
          unspecified: 'Unbestimmt',
          vehicle_restriction: 'Beschränkung auf Fahrzeugklassen',
          default: 'Keine Zuordnung',
        },
      },
      condition_category_right: {
        name: 'Parkbeschränkung rechts',
        condition: 'contains',
        type: 'string',
        format: {
          access_restriction: 'Zugangsbeschränkung',
          assumed_free: 'Wahrscheinlich keine Parkbeschränkungen',
          assumed_private: 'Sehr wahrscheinlich privat',
          bus_lane: 'Bussonderfahrstreifen',
          car_sharing: 'Nur für Carsharing-Fahrzeuge',
          charging: 'Laden von Elektrofahrzeugen',
          disabled: 'Behindertenparkplatz',
          disabled_private: 'Personenbezogener Behindertenparkplatz',
          free: 'Keine Parkbeschränkungen',
          invalid: 'Ungültige Angabe in OSM',
          loading: 'Ladezone',
          maxweight: 'Gewichtsbegrenzung',
          mixed: 'Nur mit Parkschein oder Bewohnerparkausweis',
          no_parking: 'Eingeschränktes Haltverbot',
          no_standing: 'Nur kurzes Halten erlaubt',
          no_stopping: 'Absolutes Haltverbot',
          paid: 'Nur mit Parkschein',
          private: 'Privat',
          residents: 'Nur mit Bewohnerparkausweis',
          taxi: 'Taxenstand',
          time_limited: 'Höchstparkdauer',
          unspecified: 'Unbestimmt',
          vehicle_restriction: 'Beschränkung auf Fahrzeugklassen',
          default: 'Keine Zuordnung',
        },
      },
      parking_left: {
        name: 'Parkposition links',
        condition: 'contains',
        type: 'string',
        format: {
          lane: 'Auf der Fahrbahn',
          half_on_kerb: 'Halb auf dem Gehweg',
          on_kerb: 'Ganz auf dem Gehweg',
          no_parking: 'Eingeschränktes Haltverbot',
          no_stopping: 'Absolutes Haltverbot',
          separate: 'Parkraum als separate Geometrie erfasst',
          shoulder: 'Auf dem Seitenstreifen',
          street_side: 'Parkbucht',
          yes: 'Nicht näher bestimmtes Straßenparken',
          no: 'Kein Parken (Sonstiger/Unbekannter Grund)',
          no_standing: 'Nur kurzes Halten erlaubt',
          missing: 'Daten in OSM fehlen',
          not_expected: 'Kein Parken zu erwarten',
        },
      },
      parking_right: {
        name: 'Parkposition rechts',
        condition: 'contains',
        type: 'string',
        format: {
          lane: 'Auf der Fahrbahn',
          half_on_kerb: 'Halb auf dem Gehweg',
          on_kerb: 'Ganz auf dem Gehweg',
          no_parking: 'Eingeschränktes Haltverbot',
          no_stopping: 'Absolutes Haltverbot',
          separate: 'Parkraum als separate Geometrie erfasst',
          shoulder: 'Auf dem Seitenstreifen',
          street_side: 'Parkbucht',
          yes: 'Nicht näher bestimmtes Straßenparken',
          no: 'Kein Parken (Sonstiger/Unbekannter Grund)',
          no_standing: 'Nur kurzes Halten erlaubt',
          missing: 'Daten in OSM fehlen',
          not_expected: 'Kein Parken zu erwarten',
        },
      },
      surface_left: {
        name: 'Oberfläche links',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      surface_right: {
        name: 'Oberfläche rechts',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      way_ids: 'OSM-Way-IDs',
      way_reversed: 'Way-Richtung',
      start_node: {
        name: 'Startknoten',
        type: 'number',
      },
      end_node: {
        name: 'Endknoten',
        type: 'number',
      },
    },
  },
  parkings_labels: {
    gfiAttributes: {
      capacity: {
        name: 'Stellplatzanzahl',
        type: 'number',
      },
      operator_type: {
        name: 'Betreibertyp',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      operator_type_source: {
        name: 'Herkunft des Betreibertyps',
        condition: 'contains',
        type: 'string',
        format: {
          default_fallback: 'Annahme bei fehlender Angabe.',
          driveway_inference: 'Annahme bei fehlender Angabe wenn eine Einfahrt erkannt wurde.',
          manual_overwrite_list: 'Anhand einer manuellen Korrekturliste in TILDA.',
          parent_highway_tag: 'Explizite Angabe aus OSM an der zugeordneten Straße.',
          tag: 'Explizite Angabe aus OSM.',
        },
      },
      operator_type_confidence: {
        name: 'Konfidenz des Betreibertyps',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      area: {
        name: 'Fläche',
        type: 'number',
        suffix: 'm²',
      },
      angle: {
        name: 'Textwinkel',
        type: 'number',
      },
    },
  },
  parkings_no: {
    gfiAttributes: {
      parking: {
        name: 'Parkposition',
        condition: 'contains',
        type: 'string',
        format: {
          lane: 'Auf der Fahrbahn',
          half_on_kerb: 'Halb auf dem Gehweg',
          on_kerb: 'Ganz auf dem Gehweg',
          no_parking: 'Eingeschränktes Haltverbot',
          no_stopping: 'Absolutes Haltverbot',
          separate: 'Parkraum als separate Geometrie erfasst',
          shoulder: 'Auf dem Seitenstreifen',
          street_side: 'Parkbucht',
          yes: 'Nicht näher bestimmtes Straßenparken',
          no: 'Kein Parken (Sonstiger/Unbekannter Grund)',
          no_standing: 'Nur kurzes Halten erlaubt',
          missing: 'Daten in OSM fehlen',
          not_expected: 'Kein Parken zu erwarten',
        },
      },
      reason: {
        name: 'Grund',
        condition: 'contains',
        type: 'string',
        format: {
          missing_data: 'Keine Parkraum-Daten in OpenStreetMap erfasst',
          parking_tag: 'Explizite Angabe in den Daten',
          restriction_no_parking: 'Explizites Parkverbot aus OSM',
          restriction_no_stopping: 'Explizites Halteverbot aus OSM',
          restriction_no_standing: 'Eingeschränktes Halteverbot aus OSM',
          bus_stop: 'Haltestelle',
          cycleway: 'Radverkehrsanlage',
          dual_carriage: 'Getrennte Richtungsfahrbahnen',
          junction: 'Knotenpunkt / Einmündung',
          narrow: 'Zu schmale Fahrbahn',
          capacity_below_zero: 'Abschnitt zu klein für ein Fahrzeug',
        },
      },
      condition_category: {
        name: 'Parkbeschränkung',
        condition: 'contains',
        type: 'string',
        format: {
          access_restriction: 'Zugangsbeschränkung',
          assumed_free: 'Wahrscheinlich keine Parkbeschränkungen',
          assumed_private: 'Sehr wahrscheinlich privat',
          bus_lane: 'Bussonderfahrstreifen',
          car_sharing: 'Nur für Carsharing-Fahrzeuge',
          charging: 'Laden von Elektrofahrzeugen',
          disabled: 'Behindertenparkplatz',
          disabled_private: 'Personenbezogener Behindertenparkplatz',
          free: 'Keine Parkbeschränkungen',
          invalid: 'Ungültige Angabe in OSM',
          loading: 'Ladezone',
          maxweight: 'Gewichtsbegrenzung',
          mixed: 'Nur mit Parkschein oder Bewohnerparkausweis',
          no_parking: 'Eingeschränktes Haltverbot',
          no_standing: 'Nur kurzes Halten erlaubt',
          no_stopping: 'Absolutes Haltverbot',
          paid: 'Nur mit Parkschein',
          private: 'Privat',
          residents: 'Nur mit Bewohnerparkausweis',
          taxi: 'Taxenstand',
          time_limited: 'Höchstparkdauer',
          unspecified: 'Unbestimmt',
          vehicle_restriction: 'Beschränkung auf Fahrzeugklassen',
        },
      },
      condition_category_primary: {
        name: 'Primäre Parkbeschränkung',
        condition: 'contains',
        type: 'string',
        format: {
          access_restriction: 'Zugangsbeschränkung',
          assumed_free: 'Wahrscheinlich keine Parkbeschränkungen',
          assumed_private: 'Sehr wahrscheinlich privat',
          bus_lane: 'Bussonderfahrstreifen',
          car_sharing: 'Nur für Carsharing-Fahrzeuge',
          charging: 'Laden von Elektrofahrzeugen',
          disabled: 'Behindertenparkplatz',
          disabled_private: 'Personenbezogener Behindertenparkplatz',
          free: 'Keine Parkbeschränkungen',
          invalid: 'Ungültige Angabe in OSM',
          loading: 'Ladezone',
          maxweight: 'Gewichtsbegrenzung',
          mixed: 'Nur mit Parkschein oder Bewohnerparkausweis',
          no_parking: 'Eingeschränktes Haltverbot',
          no_standing: 'Nur kurzes Halten erlaubt',
          no_stopping: 'Absolutes Haltverbot',
          paid: 'Nur mit Parkschein',
          private: 'Privat',
          residents: 'Nur mit Bewohnerparkausweis',
          taxi: 'Taxenstand',
          time_limited: 'Höchstparkdauer',
          unspecified: 'Unbestimmt',
          vehicle_restriction: 'Beschränkung auf Fahrzeugklassen',
          default: 'Keine Zuordnung',
        },
      },
      capacity: {
        name: 'Stellplatzanzahl',
        type: 'number',
      },
      capacity_source: {
        name: 'Herkunft der Stellplatzanzahl',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'Explizite Angabe aus OSM.',
          tag_estimation: 'Explizite Angabe einer Schätzung aus OSM.',
          tag_redistributed: 'Explizite Angabe aus OSM, dann anteilig aufgeteilt nach Stanzung.',
          tag_estimation_redistributed:
            'Explizite Angabe einer Schätzung aus OSM, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_parallel: 'Berechnet auf Basis der Fläche und Parkausrichtung.',
          area_and_orientation_perpendicular: 'Berechnet auf Basis der Fläche und Parkausrichtung.',
          area_and_orientation_diagonal: 'Berechnet auf Basis der Fläche und Parkausrichtung.',
          area_and_orientation_parallel_redistributed:
            'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_perpendicular_redistributed:
            'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_diagonal_redistributed:
            'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
          area_and_orientation_fallback_parallel:
            'Berechnet auf Basis der Fläche und Parkausrichtung. Allerdings war die Parkausrichtung unbekannt, so dass Parallelparken angenommen wurde.',
          estimated_from_length: 'Berechnet auf Basis der Linien-Länge und Ausrichtung.',
          estimated_from_area: 'Berechnet auf Basis der Fläche und Ausrichtung.',
          estimated: 'Berechnung',
          estimated_redistributed: 'Geschätzt, Kapazität umverteilt',
          assumed_default: 'Keine explizite Angabe vorgefunden; dieser Wert ist eine Annahme.',
        },
      },
      orientation: {
        name: 'Ausrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          parallel: 'Parallelparken',
          perpendicular: 'Querparken',
          diagonal: 'Schrägparken',
        },
      },
      staggered: {
        name: 'Parkweise',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Alternierendes Parken',
          no: 'Nicht alternierend',
        },
      },
      source: {
        name: 'Datenquelle',
        condition: 'contains',
        type: 'string',
        format: {
          parkings: 'Angaben an der Straßenlinie',
          separate_parking_areas: 'Separat erfasste Flächendaten',
          separate_parking_points: 'Separate erfasste Punktdaten',
        },
      },
      geom_sources: '(Intern) OSM-IDs der Geometrien',
      tag_sources: 'Tag-Quellen',
      road: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      road_name: 'Straßenname',
      road_oneway: {
        name: 'Einbahnstraße',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Nein (in beide Richtungen befahrbar)',
          yes: 'Einbahnstraße',
          yes_dual_carriageway: 'Einbahnstraße (getrennte Richtungsfahrbahnen)',
        },
      },
      road_width: {
        name: 'Fahrbahnbreite',
        type: 'number',
        suffix: 'm',
      },
      road_width_source: {
        name: 'Herkunft der Fahrbahnbreite',
        condition: 'contains',
        type: 'string',
        format: {
          highway_default: 'Standard-Wert für diesen Straßentyp.',
          highway_default_and_oneway: 'Standard-Wert für diesen Straßentyp als Einbahnstraße.',
          tag: 'Dieser Wert ist in OSM hinterlegt.',
        },
      },
      road_width_confidence: {
        name: 'Konfidenz der Fahrbahnbreite',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      side: {
        name: 'Straßenseite',
        condition: 'contains',
        type: 'string',
        format: {
          left: 'Links',
          right: 'Rechts',
        },
      },
      area: {
        name: 'Fläche',
        type: 'number',
        suffix: 'm²',
      },
      area_source: {
        name: 'Herkunft der Flächenangabe',
        condition: 'contains',
        type: 'string',
        format: {
          estimated: 'Berechnet auf Basis der Länge der Liniengeometrie und Fahrzeugausrichtung.',
          geometry: 'Basiert auf dem Flächeninhalt der Geometrie aus OSM.',
        },
      },
      area_confidence: {
        name: 'Konfidenz der Flächenangabe',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      capacity_confidence: {
        name: 'Konfidenz der Stellplatzanzahl',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      surface: {
        name: 'Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      surface_confidence: {
        name: 'Konfidenz der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      surface_source: {
        name: 'Herkunft der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'Explizite Angabe aus OSM',
          tag_transformed: 'Aus OSM-Tag normalisiert',
          parent_highway_tag: 'Von zugeordneter Straße (OSM)',
          parent_highway_tag_transformed: 'Von zugeordneter Straße, normalisiert',
        },
      },
      direction: {
        name: 'Einparkrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          back_in: 'Rückwärts einparken',
          head_in: 'Vorwärts einparken',
        },
      },
      location: {
        name: 'Lage im Straßenraum',
        condition: 'contains',
        type: 'string',
        format: {
          lane_centre: 'Fahrbahnmitte',
          median: 'Mittelstreifen',
        },
      },
      markings: {
        name: 'Markierungen',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Ohne Markierungen',
          yes: 'Mit Markierungen',
        },
      },
      covered: {
        name: 'Überdacht',
        condition: 'contains',
        type: 'string',
        format: {
          partial: 'Teilweise überdacht',
          yes: 'Überdacht',
        },
      },
      access: {
        name: 'Zugang',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          customers: 'Kund:innen',
          destination: 'Anlieger frei (Nicht-Durchgangsverkehr erlaubt)',
          employees: 'Mitarbeiter',
          permissive: 'Öffentliche Nutzung geduldet',
          public: 'Öffentlich (explizit)',
          delivery: 'Lieferverkehr',
          no: 'Kein Zugang',
          permit: 'Mit Genehmigung',
          residents: 'Nur mit Bewohnerparkausweis',
        },
      },
      operator_type: {
        name: 'Betreibertyp',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      operator_type_source: {
        name: 'Herkunft des Betreibertyps',
        condition: 'contains',
        type: 'string',
        format: {
          default_fallback: 'Annahme bei fehlender Angabe.',
          driveway_inference: 'Annahme bei fehlender Angabe wenn eine Einfahrt erkannt wurde.',
          manual_overwrite_list: 'Anhand einer manuellen Korrekturliste in TILDA.',
          parent_highway_tag: 'Explizite Angabe aus OSM an der zugeordneten Straße.',
          tag: 'Explizite Angabe aus OSM.',
        },
      },
      operator_type_confidence: {
        name: 'Konfidenz des Betreibertyps',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      informal: {
        name: 'Duldung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Parken im rechtlichen Graubereich oder etabliertes, geduldetes Falschparken.',
        },
      },
      zone: 'Parkzone',
      mapillary: {
        name: 'Mapillary',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      traffic_sign: 'Verkehrszeichen',
      _staggered_maneuvering_loss: {
        name: '(Intern) Manövrierraumverlust (alternierendes Parken)',
        type: 'number',
      },
      _staggered_original_capacity: {
        name: '(Intern) Ursprüngliche Kapazität (vor Staggered-Anpassung)',
        type: 'number',
      },
    },
  },
  places: {
    gfiAttributes: {
      place: {
        name: 'Ortskategorie',
        condition: 'contains',
        type: 'string',
        format: {
          borough: 'Stadtteil/Stadtbezirk',
          city: 'Stadt',
          hamlet: 'Siedlung',
          suburb: 'Stadtteil',
          town: 'Stadt oder große Gemeinde',
          village: 'Dorf',
        },
      },
      capital: 'Hauptstadtstatus',
      population: {
        name: 'Einwohner:innen-Anzahl',
        type: 'number',
        suffix: 'Einwohner:innen',
      },
      population_date: 'Datum der Quelle der Einwohner:innen-Anzahl',
      admin_level: {
        name: 'Admin-Level',
        type: 'number',
      },
      name: 'Name',
      website: 'Website',
      wikidata: 'Wikidata',
      wikipedia: 'Wikipedia',
    },
  },
  poiClassification: {
    gfiAttributes: {
      name: 'Name POI',
      addr_street: 'Straße',
      addr_zip: 'Postleitzahl',
      addr_city: 'Ort',
      addr_number: 'Hausnummer',
      category: {
        name: 'Kategorisierung des POI',
        condition: 'contains',
        type: 'string',
        format: {
          Grundversorgung: 'Grundversorgung',
          Bildung: 'Bildung',
          Einkauf: 'Einkauf',
          Freizeit: 'Freizeit',
        },
      },
      type: {
        name: 'Detail-Kategorie',
        condition: 'contains',
        type: 'string',
        format: {
          'leisure-pitch': 'Sportplatz',
          'leisure-playground': 'Spielplatz',
          'amenity-restaurant': 'Restaurant',
          'amenity-place_of_worship': 'Andachtsstätte',
          'amenity-kindergarten': 'Kindergarten',
          'tourism-artwork': 'Kunst',
          'amenity-fast_food': 'Schnellimbiss',
          'shop-hairdresser': 'Friseur',
          'amenity-doctors': 'Arzt',
          'leisure-sports_centre': 'Sportzentrum / -komplex',
          'amenity-school': 'Schule',
          'shop-clothes': 'Bekleidungsgeschäft',
          'shop-supermarket': 'Supermarkt',
          'shop-bakery': 'Bäckerei',
          'amenity-cafe': 'Café',
          'tourism-picnic_site': 'Picknickplatz',
          'tourism-viewpoint': 'Aussichtspunkt',
          'amenity-social_facility': 'Sozialeinrichtung',
          'tourism-hotel': 'Hotel',
          'shop-car_repair': 'Autowerkstatt',
          'leisure-swimming_pool': 'Schwimmbecken',
          'tourism-attraction': 'Sehenswürdigkeit',
          'amenity-bank': 'Bank-Filiale',
          'amenity-community_centre': 'Gemeindezentrum',
          'shop-car': 'Autohändler',
          'amenity-fuel': 'Tankstelle',
          'amenity-pharmacy': 'Apotheke',
          'amenity-dentist': 'Zahnarzt',
          'amenity-pub': 'Kneipe',
          'tourism-guest_house': 'Pension',
          'shop-beauty': 'Schönheitssalon',
          'tourism-chalet': 'Ferienhaus',
          'shop-kiosk': 'Kiosk',
          'shop-florist': 'Blumenhändler',
          'shop-butcher': 'Metzgerei',
          'amenity-post_office': 'Postfiliale',
          'amenity-car_wash': 'Autowäsche',
          'shop-convenience': 'Minimarkt',
          'tourism-museum': 'Museum',
          'shop-optician': 'Optiker',
          'shop-beverages': 'Getränkehandel',
          'amenity-driving_school': 'Fahrschule',
          'amenity-bar': 'Bar',
          'amenity-townhall': 'Rathaus, Gemeindeamt',
          'shop-vacant': 'Leerstehendes Geschäft',
          'shop-bicycle': 'Fahrradladen',
          'tourism-camp_pitch': 'Zeltplatz/Wohnwagenplatz',
          'leisure-fitness_centre': 'Fitness-Studio',
          'shop-shoes': 'Schuhgeschäft',
          'shop-jewelry': 'Juwelier',
          'shop-farm': 'Hofladen',
          'shop-furniture': 'Möbelhaus',
          'leisure-sports_hall': 'Sporthalle',
          'shop-travel_agency': 'Reisebüro',
          'amenity-library': 'Bibliothek',
          'amenity-biergarten': 'Biergarten',
          'amenity-ice_cream': 'Eisgeschäft',
          'shop-chemist': 'Drogerie',
          'shop-doityourself': 'Heimwerkerladen',
          'amenity-veterinary': 'Tierarztpraxis',
          'amenity-bicycle_rental': 'Fahrradverleih',
          'leisure-horse_riding': 'Reitanlage',
          'amenity-bbq': 'Grill',
          'shop-mobile_phone': 'Mobiltelefonladen',
          'shop-electronics': 'Elektronikfachgeschäft',
          'shop-variety_store': 'Sonderpostenmarkt',
          'shop-books': 'Buchhandlung',
          'shop-gift': 'Geschenkeladen',
          'tourism-camp_site': 'Campingplatz',
          'tourism-caravan_site': 'Wohnmobil-Stellplatz',
          'shop-funeral_directors': 'Beerdigungsinstitut',
          'shop-interior_decoration': 'Innenausstattungsgeschäft',
          'shop-massage': 'Massagesalon',
          'shop-tailor': 'Schneider',
          'shop-hearing_aids': 'Hörgerätegeschäft',
          'amenity-childcare': 'Kinderbetreuung',
          'shop-garden_centre': 'Gartenzentrum',
          'tourism-information': 'Information',
          'shop-medical_supply': 'Sanitätshaus',
          'leisure-water_park': 'Erlebnisbad',
          'amenity-theatre': 'Theater',
          'shop-sports': 'Sportgeschäft',
          'shop-pet': 'Zoofachgeschäft',
          'shop-tattoo': 'Tätowierer',
          'shop-stationery': 'Schreibwarengeschäft',
          'amenity-clinic': 'Ärztezentrum',
          'shop-trade': 'Baustoffhandel',
          'shop-wine': 'Weinhandel',
          'leisure-stadium': 'Stadion',
          'amenity-events_venue': 'Veranstaltungsstätte',
          'shop-yes': 'Geschäft (nicht spezifizierter Typ)',
          'shop-cosmetics': 'Kosmetikladen',
          'amenity-hospital': 'Krankenhaus',
          'shop-deli': 'Feinkostladen',
          'shop-greengrocer': 'Obst- und Gemüseladen',
          'tourism-hostel': 'Hostel',
          'amenity-car_rental': 'Autovermietung',
          'amenity-arts_centre': 'Kunstzentrum',
          'shop-computer': 'Fachgeschäft für Computer',
          'amenity-marketplace': 'Marktplatz',
          'shop-laundry': 'Wäscherei',
          'amenity-college': 'Hochschule',
          'shop-toys': 'Spielwarengeschäft',
          'amenity-music_school': 'Musikschule',
          'shop-kitchen': 'Küchenfachmarkt',
          'shop-motorcycle': 'Motorradhändler',
          'shop-dry_cleaning': 'Chemische Reinigung',
          'shop-car_parts': 'Autoteilehandel',
          'amenity-nightclub': 'Diskothek',
          'shop-alcohol': 'Spirituosenladen',
          'shop-hardware': 'Eisenwarenhandel',
          'shop-tyres': 'Reifenhandel',
          'shop-mall': 'Einkaufszentrum',
          'shop-department_store': 'Kaufhaus',
          'shop-ticket': 'Eintrittskartenverkäufer',
          'shop-art': 'Kunsthandlung',
          'amenity-university': 'Universität',
          'shop-second_hand': 'Second-Hand-Laden',
          'shop-wholesale': 'Großhandel',
          'amenity-cinema': 'Kino',
          'shop-newsagent': 'Zeitschriftenhandel',
          'shop-fabric': 'Stoffgeschäft',
          'shop-tobacco': 'Tabakwarengeschäft',
          'amenity-vehicle_inspection': 'Fahrzeuginspektion',
          'shop-antiques': 'Antiquitätenhändler',
          'shop-bed': 'Betten- / Matratzengeschäft',
          'shop-copyshop': 'Kopierladen',
          'amenity-courthouse': 'Gericht',
          'shop-photo': 'Fotofachgeschäft',
          'shop-perfumery': 'Parfümerie',
          'shop-houseware': 'Haushaltswarengeschäft',
          'tourism-zoo': 'Zoo',
          'shop-coffee': 'Kaffeegeschäft',
          'shop-musical_instrument': 'Musikinstrumentegeschäft',
          'shop-confectionery': 'Süßwarenladen',
          'shop-bookmaker': 'Wettbüro',
          'amenity-gambling': 'Spielhalle',
          'leisure-swimming_area': 'Natürlicher Badebereich',
          'shop-seafood': 'Fischgeschäft',
          'shop-craft': 'Geschäft für Künstlerbedarf',
          'leisure-picnic_table': 'Picknicktisch',
          'shop-paint': 'Farbengeschäft',
          'amenity-public_building': 'Öffentliches Gebäude',
          'amenity-boat_rental': 'Bootsvermietung',
          'shop-outdoor': 'Outdoorgeschäft',
          'shop-locksmith': 'Schlüsseldienst',
          'amenity-post_depot': 'Postverteilzentrum',
          'leisure-golf_course': 'Golfplatz',
          'amenity-casino': 'Kasino',
          'amenity-prep_school': 'Vorschule',
          'shop-tea': 'Teegeschäft',
          'shop-pet_grooming': 'Tierfriseur',
          'shop-telecommunication': 'Telekommunikationsfachgeschäft',
          'amenity-social_centre': 'Sozialzentrum',
          'shop-charity': 'Sozialkaufhaus',
          'shop-agrarian': 'Agrarmarkt',
          'shop-hifi': 'HiFi-Laden',
          'amenity-animal_training': 'Tiertraining',
          'shop-lottery': 'Lottoannahmestelle',
          'shop-storage_rental': 'Lagerraumvermieter',
          'shop-bathroom_furnishing': 'Badeinrichtungsgeschäft',
          'shop-pastry': 'Konditorei',
          'shop-electrical': 'Elektrofachgeschaft',
          'shop-bag': 'Taschen / Koffergeschäft',
          'shop-music': 'Musikgeschäft',
          'shop-rental': 'Verleih',
          'shop-tiles': 'Fliesenhändler',
          'amenity-dojo': 'Kampfsportstudio',
          'shop-e-cigarette': 'E-Zigarettenladen',
          'shop-watches': 'Uhrengeschäft',
          'leisure-bathing_place': 'Badeplatz',
          'shop-fireplace': 'Kachelofenladen',
          'shop-health_food': 'Reformhaus',
          'amenity-animal_boarding': 'Tierpension',
          'shop-carpet': 'Teppichgeschäft',
          'shop-curtain': 'Vorhanggeschäft',
          'amenity-language_school': 'Sprachschule',
          'amenity-research_institute': 'Forschungseinrichtung',
          'shop-fishing': 'Angelgeschäft',
          'tourism-theme_park': 'Themenpark',
          'shop-sewing': 'Geschäft für Nähzubehör',
          'amenity-dancing_school': 'Tanzschule',
          'shop-erotic': 'Erotikgeschäft',
          'shop-fashion_accessories': 'Geschäft für Modeaccessoires',
          'shop-general': 'Gemischtwarenhandlung',
          'shop-boutique': 'Boutique',
          'shop-leather': 'Lederwarengeschäft',
          'amenity-stables': 'Reitstall',
          'amenity-canteen': 'Kantine',
          'shop-baby_goods': 'Babyausstattung',
          'leisure-park': 'Park',
          'shop-appliance': 'Haushaltselektrogerätegeschäft',
          'shop-pottery': 'Keramikladen',
          'amenity-traffic_park': 'Verkehrsübungsplatz',
          'amenity-prison': 'Gefängnisanlage',
          'shop-caravan': 'Wohnwagengeschäft',
          'shop-lighting': 'Leuchten- und Lampengeschäft',
          'shop-pawnbroker': 'Pfandleihe',
          'shop-cheese': 'Käseladen',
          'shop-motorcycle_repair': 'Motorradwerkstatt',
          'tourism-motel': 'Motel',
          'shop-frame': 'Bilderrahmengeschäft',
          'shop-window_blind': 'Fensterladengeschäft',
          'shop-chocolate': 'Schokoladenladen',
          'shop-weapons': 'Waffengeschäft',
          'leisure-beach_resort': 'Strandresort',
          'tourism-gallery': 'Kunstgalerie',
          'shop-shoe_repair': 'Schuhreparatur',
          'shop-repair': 'Reparaturgeschäft',
          'shop-model': 'Modellbaugeschäft',
          'shop-glaziery': 'Glaserei',
          'shop-estate_agent': 'Immobilienbüro',
          'shop-wool': 'Wollladen',
          'shop-honey': 'Honiggeschäft',
          'shop-flooring': 'Fußbodengeschäft',
          'amenity-internet_cafe': 'Internetcafé',
          'shop-gas': 'Gasflaschenverkauf',
          'shop-gold_buyer': 'Goldankauf',
          'leisure-firepit': 'Feuerstelle',
          'shop-video': 'Videothek',
          'shop-collector': 'Sammlergeschäft',
          'amenity-conference_centre': 'Kongresszentrum',
          'shop-tool_hire': 'Werkzeugverleih',
          'shop-games': 'Brettspielgeschäft',
          'leisure-garden': 'Garten',
          'shop-radiotechnics': 'Radio / Elektronik-Geschäft',
          'amenity-boat_storage': 'Bootslagerplatz',
          'shop-hairdresser_supply': 'Friseurbedarf',
          'shop-party': 'Partyzubehör',
          'shop-cannabis': 'Cannabisgeschäft',
          'shop-doors': 'Türgeschäft',
          'shop-outpost': 'Abholstelle eines Onlinehändlers',
          'amenity-vending_machine': 'Verkaufsautomat',
          'leisure-adult_gaming_centre': 'Spielothek für Erwachsene',
          'shop-printing': 'Druckerei',
          'shop-boat': 'Bootsgeschäft',
          'shop-nutrition_supplements': 'Nahrungsergänzungsmittelgeschäft',
          'shop-fuel': 'Tankstelle',
          'shop-truck_repair': 'Lkw-Werkstatt',
          'leisure-outdoor_seating': 'Außengastronomie',
          'shop-vacuum_cleaner': 'Staubsaugergeschäft',
          'shop-hookah': 'Shisha-Shop',
          'amenity-money_transfer': 'Geldtransferstation',
          'shop-security': 'Sicherheitsfachgeschäft',
          'shop-spices': 'Gewürzladen',
          'tourism-alpine_hut': 'Berghütte',
          'shop-truck': 'Lkw-Handel',
          'tourism-apartment': 'Ferienwohnung',
          'shop-scuba_diving': 'Tauchwarengeschäft',
          'tourism-trail_riding_station': 'Reitstation',
          'leisure-bird_hide': 'Vogelbeobachtungsstation',
          'shop-wigs': 'Perückenladen',
          'shop-country_store': 'Dorfladen',
          'shop-plant_hire': 'Maschinenvermietung',
          'shop-food': 'Lebensmittelgeschäft',
          'shop-groundskeeping': 'Geschäft für Gartengeräte',
          'shop-video_games': 'Videospielgeschäft',
          'amenity-fallback': 'Einrichtung (Auffangkategorie)',
          'leisure-fallback': 'Freizeit (Auffangkategorie)',
          'shop-fallback': 'Geschäft (Auffangkategorie)',
          'tourism-fallback': 'Tourismus (Auffangkategorie)',
        },
      },
      formalEducation: {
        name: 'Bildungseinrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          childcare: 'Kinderbetreuung',
          college: 'Berufsfachschule / Weiterbildungseinrichtung',
          kindergarten: 'Kindergarten',
          research_institute: 'Forschungsinstitut',
          school: 'Schule',
          university: 'Universität',
        },
      },
    },
  },
  publicTransport: {
    gfiAttributes: {
      category: {
        name: 'Art',
        condition: 'contains',
        type: 'string',
        format: {
          ferry_station: 'Fähranleger',
          light_rail_station: 'S-Bahn-Station',
          railway_station: 'Bahnhof regional / überregional',
          subway_station: 'U-Bahn-Station',
          tram_station: 'Tramstation',
          undefined: 'Nicht kategorisiert',
        },
      },
      name: 'Name',
      operator: 'Betreiber',
      wikidata: 'Wikidata',
      wikipedia: 'Wikipedia',
      description: 'Beschreibung',
      network: 'Verkehrsnetz',
      network_short: 'Verkehrsnetz (Kurzname)',
    },
  },
  roads: {
    gfiAttributes: {
      road: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      highway: {
        name: 'OSM-Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          cycleway: 'Radweg',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway: 'Autobahn',
          motorway_link: 'Zufahrt einer Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          road: 'Unkategorisierte Straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          service: 'Zufahrtsweg',
          steps: 'Stufen',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          trunk: 'Kraftfahrstraße',
          trunk_link: 'Kraftfahrstraßen-Anschluss',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
        },
      },
      name: 'Name',
      name_ref: 'Referenzname',
      length: {
        name: 'Länge',
        type: 'number',
        suffix: 'm',
      },
      lifecycle: {
        name: 'Status',
        condition: 'contains',
        type: 'string',
        format: {
          blocked: 'Gesperrt (Sperrung)',
          construction: 'In Bau',
          construction_no_access: 'Gesperrt aufgrund einer Baustelle',
          temporary: 'Temporärer Weg',
        },
      },
      width: {
        name: 'Breite',
        type: 'number',
        suffix: 'm',
      },
      width_effective: {
        name: 'Effektive Breite',
        type: 'number',
        suffix: 'm',
      },
      width_source: {
        name: 'Quelle Breite',
        condition: 'contains',
        type: 'string',
        format: {
          ALKIS: 'Aus ALKIS Daten ausgemessen',
          ARCore: 'Mit dem Handy-Metermaß von StreetComplete gemessen',
        },
      },
      oneway: {
        name: 'Verkehrsrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Beide Richtungen',
          yes: 'Einbahnstraße',
          yes_dual_carriageway: 'Einbahnstraße da separate Geometrie pro Seite',
        },
      },
      oneway_bicycle: {
        name: 'Verkehrsrichtung Fahrrad',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Beide Richtungen für Radverkehr',
          yes: 'Eine Richtung (auch für Radverkehr)',
        },
      },
      bridge: {
        name: 'Brücke',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Ja',
        },
      },
      tunnel: {
        name: 'Tunnel',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Ja',
        },
      },
      mapillary_coverage: {
        name: 'Mapillary-Abdeckung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary: {
        name: 'Straßenfotos (Mapillary)',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_forward: {
        name: 'Mapillary in Linienrichtung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_backward: {
        name: 'Mapillary gegen Linienrichtung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_traffic_sign: {
        name: 'Mapillary für Verkehrszeichen',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      route_relations: 'Routen',
      traffic_sign: {
        name: 'Beschilderung',
        condition: 'contains',
        type: 'string',
        format: {
          none: 'Unbeschildert',
        },
      },
      'traffic_sign:forward': {
        name: 'Beschilderung in Verkehrsrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          none: 'Unbeschildert',
        },
      },
      'traffic_sign:backward': {
        name: 'Beschilderung in Gegenrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          none: 'Unbeschildert',
        },
      },
      description: 'Hinweis aus OSM',
      operator_type: {
        name: 'Betreibertyp',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      informal: {
        name: 'Trampelpfad',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Weg als informeller Weg erfasst',
        },
      },
      covered: {
        name: 'Überdacht',
        condition: 'contains',
        type: 'string',
        format: {
          covered: 'Überdacht',
          partial: 'Teilweise überdacht',
          indoor: 'In einem Gebäude',
        },
      },
      bikelane_left: {
        name: 'Radinfrastruktur links',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
          data_no: 'Vollständig (explizit keine)',
          not_expected: 'Keine Infrastruktur erwartet',
          separate_geometry: 'RVA als separate Geometrie erfasst',
          assumed_no: 'Vermutlich vollständig',
          missing: 'Unvollständig',
        },
      },
      bikelane_self: {
        name: 'Radinfrastruktur mittig',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
          data_no: 'Vollständig (explizit keine)',
          not_expected: 'Keine Infrastruktur erwartet',
          separate_geometry: 'RVA als separate Geometrie erfasst',
          assumed_no: 'Vermutlich vollständig',
          missing: 'Unvollständig',
        },
      },
      bikelane_right: {
        name: 'Radinfrastruktur rechts',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
          data_no: 'Vollständig (explizit keine)',
          not_expected: 'Keine Infrastruktur erwartet',
          separate_geometry: 'RVA als separate Geometrie erfasst',
          assumed_no: 'Vermutlich vollständig',
          missing: 'Unvollständig',
        },
      },
      maxspeed: {
        name: 'Höchstgeschwindigkeit',
        type: 'number',
        suffix: 'km/h',
      },
      maxspeed_source: {
        name: 'Höchstgeschwindigkeit Quelle',
        condition: 'contains',
        type: 'string',
        format: {
          maxspeed: 'In OSM erfasst als Tag `maxspeed`',
          maxspeed_tag: 'In OSM erfasst über einen `maxspeed`-Kategorie-Tag',
          zone: 'OSM-Zonen-Tag',
          inferred_from_highway: 'Abgeleitet vom `highway`-Tag',
        },
      },
      maxspeed_confidence: {
        name: 'Konfidenz Höchstgeschwindigkeit',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      'osm_maxspeed:backward': 'Spezielle Höchstgeschwindigkeit gegen die Linienrichtung',
      'osm_maxspeed:forward': 'Spezielle Höchstgeschwindigkeit mit der Linienrichtung',
      'osm_maxspeed:conditional': 'Spezielle Höchstgeschwindigkeit mit Einschränkungen',
      lit: {
        name: 'Beleuchtung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Beleuchtet',
          no: 'Nicht beleuchtet',
          special: 'Spezielle Angaben',
        },
      },
      surface: {
        name: 'Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      surface_source: {
        name: 'Herkunft der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'Explizite Angabe aus OSM',
          tag_transformed: 'Aus OSM-Tag normalisiert',
          parent_highway_tag: 'Von zugeordneter Straße (OSM)',
          parent_highway_tag_transformed: 'Von zugeordneter Straße, normalisiert',
        },
      },
      surface_confidence: {
        name: 'Konfidenz der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      smoothness: {
        name: 'Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          excellent: 'Sehr gut',
          good: 'Gut',
          intermediate: 'Mittel gut',
          bad: 'Schlecht',
          very_bad: 'Sehr schlecht',
        },
      },
      smoothness_source: {
        name: 'Herkunft der Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'OSM-Tag `smoothness`',
          tag_normalized: 'OSM-Tag `smoothness` (normalisiert)',
          surface_to_smoothness: 'Abgeleitet von `surface`',
          tracktype_to_smoothness: 'Abgeleitet von `tracktype`',
          'mtb:scale_to_smoothness': 'Abgeleitet von `mtb:scale`',
        },
      },
      smoothness_confidence: {
        name: 'Konfidenz Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
        },
      },
      surface_color: {
        name: 'Ober&shy;flächen&shy;farbe',
        condition: 'contains',
        type: 'string',
        format: {
          red: 'Rot',
          green: 'Grün',
          'red;green': 'Rot und Grün',
          no: 'Keine besondere Farbe',
        },
      },
      todos: 'Todo-Liste',
    },
  },
  roadsPathClasses: {
    gfiAttributes: {
      road: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      name: 'Name',
      length: {
        name: 'Länge',
        type: 'number',
        suffix: 'm',
      },
      lifecycle: {
        name: 'Status',
        condition: 'contains',
        type: 'string',
        format: {
          blocked: 'Gesperrt (Sperrung)',
          construction: 'In Bau',
          construction_no_access: 'Gesperrt aufgrund einer Baustelle',
          temporary: 'Temporärer Weg',
        },
      },
      oneway: {
        name: 'Verkehrsrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Beide Richtungen',
          yes: 'Einbahnstraße',
          yes_dual_carriageway: 'Einbahnstraße da separate Geometrie pro Seite',
        },
      },
      oneway_bicycle: {
        name: 'Verkehrsrichtung Fahrrad',
        condition: 'contains',
        type: 'string',
        format: {
          no: 'Beide Richtungen für Radverkehr',
          yes: 'Eine Richtung (auch für Radverkehr)',
        },
      },
      mapillary_coverage: {
        name: 'Mapillary-Abdeckung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary: {
        name: 'Straßenfotos (Mapillary)',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_forward: {
        name: 'Mapillary in Linienrichtung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_backward: {
        name: 'Mapillary gegen Linienrichtung',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      mapillary_traffic_sign: {
        name: 'Mapillary für Verkehrszeichen',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      route_relations: 'Routen',
      traffic_sign: {
        name: 'Beschilderung',
        condition: 'contains',
        type: 'string',
        format: {
          none: 'Unbeschildert',
        },
      },
      description: 'Hinweis aus OSM',
      operator_type: {
        name: 'Betreibertyp',
        condition: 'contains',
        type: 'string',
        format: {
          private: 'Privat',
          public: 'Öffentlich',
        },
      },
      informal: {
        name: 'Trampelpfad',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Weg als informeller Weg erfasst',
        },
      },
      covered: {
        name: 'Überdacht',
        condition: 'contains',
        type: 'string',
        format: {
          covered: 'Überdacht',
          partial: 'Teilweise überdacht',
          indoor: 'In einem Gebäude',
        },
      },
      lit: {
        name: 'Beleuchtung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Beleuchtet',
          no: 'Nicht beleuchtet',
          special: 'Spezielle Angaben',
        },
      },
      width: {
        name: 'Breite',
        type: 'number',
        suffix: 'm',
      },
      width_source: {
        name: 'Quelle Breite',
        condition: 'contains',
        type: 'string',
        format: {
          ALKIS: 'Aus ALKIS Daten ausgemessen',
          ARCore: 'Mit dem Handy-Metermaß von StreetComplete gemessen',
        },
      },
      surface: {
        name: 'Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      surface_source: {
        name: 'Herkunft der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'Explizite Angabe aus OSM',
          tag_transformed: 'Aus OSM-Tag normalisiert',
          parent_highway_tag: 'Von zugeordneter Straße (OSM)',
          parent_highway_tag_transformed: 'Von zugeordneter Straße, normalisiert',
        },
      },
      surface_confidence: {
        name: 'Konfidenz der Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
          low: 'Niedrig',
        },
      },
      smoothness: {
        name: 'Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          excellent: 'Sehr gut',
          good: 'Gut',
          intermediate: 'Mittel gut',
          bad: 'Schlecht',
          very_bad: 'Sehr schlecht',
        },
      },
      smoothness_source: {
        name: 'Herkunft der Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          tag: 'OSM-Tag `smoothness`',
          tag_normalized: 'OSM-Tag `smoothness` (normalisiert)',
          surface_to_smoothness: 'Abgeleitet von `surface`',
          tracktype_to_smoothness: 'Abgeleitet von `tracktype`',
          'mtb:scale_to_smoothness': 'Abgeleitet von `mtb:scale`',
        },
      },
      smoothness_confidence: {
        name: 'Konfidenz Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          high: 'Hoch',
          medium: 'Mittel',
        },
      },
      surface_color: {
        name: 'Ober&shy;flächen&shy;farbe',
        condition: 'contains',
        type: 'string',
        format: {
          red: 'Rot',
          green: 'Grün',
          'red;green': 'Rot und Grün',
          no: 'Keine besondere Farbe',
        },
      },
      bikelane_left: {
        name: 'Radinfrastruktur links',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
          data_no: 'Vollständig (explizit keine)',
          not_expected: 'Keine Infrastruktur erwartet',
          separate_geometry: 'RVA als separate Geometrie erfasst',
          assumed_no: 'Vermutlich vollständig',
          missing: 'Unvollständig',
        },
      },
      bikelane_self: {
        name: 'Radinfrastruktur mittig',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
          data_no: 'Vollständig (explizit keine)',
          not_expected: 'Keine Infrastruktur erwartet',
          separate_geometry: 'RVA als separate Geometrie erfasst',
          assumed_no: 'Vermutlich vollständig',
          missing: 'Unvollständig',
        },
      },
      bikelane_right: {
        name: 'Radinfrastruktur rechts',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
          data_no: 'Vollständig (explizit keine)',
          not_expected: 'Keine Infrastruktur erwartet',
          separate_geometry: 'RVA als separate Geometrie erfasst',
          assumed_no: 'Vermutlich vollständig',
          missing: 'Unvollständig',
        },
      },
      todos: 'Todo-Liste',
      adjoining_road: {
        name: 'Straßentyp der angrenzenden Straße',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      adjoining_maxspeed: {
        name: 'Höchstgeschwindigkeit der angrenzenden Straße',
        type: 'number',
        suffix: 'km/h',
      },
    },
  },
  routing: {
    gfiAttributes: {
      category: {
        name: 'Bauliche Führung',
        condition: 'contains',
        type: 'string',
        format: {
          bicycleRoad: 'Fahrradstraße',
          bicycleRoad_vehicleDestination: 'Fahrradstraße mit Anlieger/Kfz frei',
          crossing: 'Straßenquerung',
          cycleway_adjoining: 'Radweg (straßenbegleitend)',
          cycleway_adjoiningOrIsolated:
            'Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          cycleway_isolated: 'Radweg, selbstständig geführt',
          cyclewayLink: 'Radweg-Verbindungsstück',
          cyclewayOnHighway_advisory: 'Schutzstreifen',
          cyclewayOnHighway_advisoryOrExclusive:
            'Radfahrstreifen oder Schutzstreifen (Kategorisierung unklar)',
          cyclewayOnHighway_exclusive: 'Radfahrstreifen',
          cyclewayOnHighwayBetweenLanes: 'Radfahrstreifen in Mittellage (Fahrradweiche)',
          cyclewayOnHighwayProtected: 'Geschützter Radfahrstreifen (PBL)',
          footAndCyclewaySegregated_adjoining: 'Getrennter Rad- und Gehweg, straßenbegleitend',
          footAndCyclewaySegregated_adjoiningOrIsolated:
            'Getrennter Rad- und Gehweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewaySegregated_isolated: 'Getrennter Rad- und Gehweg, selbstständig geführt',
          footAndCyclewayShared_adjoining: 'Gemeinsamer Geh- und Radweg, straßenbegleitend',
          footAndCyclewayShared_adjoiningOrIsolated:
            'Gemeinsamer Geh- und Radweg (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footAndCyclewayShared_isolated: 'Gemeinsamer Geh- und Radweg, selbstständig geführt',
          footwayBicycleYes_adjoining: 'Gehweg mit Radfahrer frei, straßenbegleitend',
          footwayBicycleYes_adjoiningOrIsolated:
            'Gehweg mit Radfahrer frei (Straßenbegleitend oder selbstständig geführt; Kategorisierung unklar)',
          footwayBicycleYes_isolated: 'Gehweg mit Radfahrer frei, selbstständig geführt',
          pedestrianAreaBicycleYes: 'Fußgängerzone, Fahrrad frei',
          sharedBusLaneBikeWithBus: 'Radfahrstreifen mit Freigabe Busverkehr',
          sharedBusLaneBusWithBike: 'Bussonderfahrstreifen mit Fahrrad frei',
          sharedMotorVehicleLane: 'Anteilig genutzter Fahrstreifen (Sharrows)',
          needsClarification: 'Führungsform unklar',
          mixedTrafficMotor: 'Mischverkehr mit Kfz-Verkehr',
          mixedTrafficFoot: 'Mischverkehr mit Fußverkehr',
        },
      },
      road: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      parent_road: {
        name: 'Straßentyp',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      adjoining_road: {
        name: 'Straßentyp der angrenzenden Straße',
        condition: 'contains',
        type: 'string',
        format: {
          bicycle_road: 'Fahrradstraße',
          construction: 'Straße ist in Bau',
          cycleway_crossing: 'Straßenquerung (Radweg)',
          cycleway: 'Radweg',
          footway_cycleway_crossing: 'Straßenquerung (Fuß- und Radweg)',
          footway_crossing: 'Straßenquerung (Fußweg)',
          footway_sidewalk: 'Gehweg',
          footway_steps: 'Treppe',
          footway: 'Fußweg',
          living_street: 'Verkehrsberuhigter Bereich',
          motorway_link: 'Zufahrt einer Autobahn',
          motorway: 'Autobahn',
          path: 'Weg / Pfad',
          pedestrian: 'Fußgängerzone',
          primary_link: 'Zufahrt einer Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          primary: 'Bundes&shy;straße/Haupt&shy;verbindungs&shy;straße',
          residential: 'Anwohnerstraße',
          residential_priority_road: 'residential_priority_road',
          secondary_link: 'Zufahrt einer Landes&shy;straße/wichtigen Durchgangs&shy;straße',
          secondary: 'Landes&shy;straße/Wichtige Durchgangs&shy;straße',
          service_alley: 'Gasse',
          service_driveway: 'Grundstückszufahrt',
          service_emergency_access: 'Rettungsweg',
          service_parking_aisle: 'Parkplatzweg',
          service_road: 'Zufahrtsweg',
          service_uncategorized: 'Zufahrtsweg (unbekannte Klassifizierung)',
          tertiary_link: 'Zufahrt einer Kreis&shy;straße/untergeordneten Durchgangs&shy;straße',
          tertiary: 'Kreis&shy;straße/Untergeordnete Durchgangs&shy;straße',
          track: 'Wald- / Feldweg',
          unclassified: 'Nebenstraße mit Verbindungscharakter',
          unspecified_road: 'Unkategorisierte Straße',
        },
      },
      adjoining_maxspeed: {
        name: 'Höchstgeschwindigkeit der angrenzenden Straße',
        type: 'number',
        suffix: 'km/h',
      },
      maxspeed: {
        name: 'Höchstgeschwindigkeit',
        type: 'number',
        suffix: 'km/h',
      },
      prefix: {
        name: 'Quellpräfix',
        condition: 'contains',
        type: 'string',
        format: {
          cycleway: 'Aus `cycleway:*`-Tags extrahiert',
          sidewalk: 'Aus `sidewalk:*`-Tags extrahiert',
        },
      },
      offset: {
        name: 'Linien-Offset',
        type: 'number',
        suffix: 'm',
      },
      side: 'Seite',
      oneway: {
        name: 'Einbahnrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Einbahnig (in Linienrichtung)',
          no: 'In beide Richtungen',
        },
      },
      oneway_motor: {
        name: 'Einbahnstraße nur für Kfz',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Kfz einbahnig, Rad in beide Richtungen',
        },
      },
      parent_id: 'Parent-Way',
      source_table: {
        name: 'Quelltabelle',
        condition: 'contains',
        type: 'string',
        format: {
          bikelanes: 'Radinfrastruktur',
          roads: 'Straßen',
          roadsPathClasses: 'Wege',
        },
      },
      source_id: 'Quell-ID',
      name: 'Name',
      length: {
        name: 'Länge',
        type: 'number',
        suffix: 'm',
      },
      surface: {
        name: 'Oberfläche',
        condition: 'contains',
        type: 'string',
        format: {
          asphalt: 'Asphalt',
          paved: 'Befestigt (unspezifisch)',
          unpaved: 'Unbefestigt',
          concrete: 'Beton',
          'concrete:plates': 'Betonplatten',
          'concrete:lanes': 'Betonstreifen / -bahnen',
          paving_stones: 'Verbund&shy;pflastersteine',
          'paving_stones:lanes': 'Pflasterstein&shy;bahnen',
          sett: 'Behauenes Pflaster / Natursteinpflaster',
          mosaic_sett: 'Mosaikpflaster',
          small_sett: 'Kleinpflaster',
          large_sett: 'Großpflaster',
          bricks: 'Ziegel',
          stone: 'Stein',
          ground: 'Erde/Boden',
          grass: 'Gras',
          sand: 'Sand',
          compacted: 'Verdichteter Untergrund',
          fine_gravel: 'Splitt',
          gravel: 'Schotter',
          pebblestone: 'Kieselsteine',
          wood: 'Holz',
          woodchips: 'Hackschnitzel',
          metal: 'Metall',
          metal_grid: 'Metallgitter',
          plastic: 'Kunststoff',
          rubber: 'Gummi',
          grass_paver: 'Rasengitter / Grasgitter',
        },
      },
      smoothness: {
        name: 'Ober&shy;flächen&shy;qualität',
        condition: 'contains',
        type: 'string',
        format: {
          excellent: 'Sehr gut',
          good: 'Gut',
          intermediate: 'Mittel gut',
          bad: 'Schlecht',
          very_bad: 'Sehr schlecht',
        },
      },
      width: {
        name: 'Breite',
        type: 'number',
        suffix: 'm',
      },
      access_bicycle: {
        name: 'Zugang Radverkehr',
        condition: 'contains',
        type: 'string',
        format: {
          yes: 'Ja',
          no: 'Nein',
          designated: 'Gebaut / vorgesehen',
          permissive: 'Geduldet',
          use_sidepath: 'Seitenweg benutzen',
          optional_sidepath: 'Seitenweg optional',
          discouraged: 'Unerwünscht',
          dismount: 'Absteigen',
        },
      },
    },
  },
  todos_lines: {
    gfiAttributes: {
      source_table: {
        name: 'Quelle',
        condition: 'contains',
        type: 'string',
        format: {
          roads: 'Straßen',
          bikelanes: 'Radinfrastruktur',
        },
      },
      length: {
        name: 'Länge',
        type: 'number',
        suffix: 'm',
      },
      todos: 'Todo-Liste',
    },
  },
  trafficSigns: {
    gfiAttributes: {
      traffic_sign: 'Verkehrszeichen',
      offset: {
        name: 'Offset entlang der Linie',
        type: 'number',
        suffix: 'm',
      },
      direction: {
        name: 'Ausrichtung',
        type: 'number',
      },
      direction_source: {
        name: 'Herkunft der Ausrichtung',
        condition: 'contains',
        type: 'string',
        format: {
          tag_degrees: 'Aus OSM-Tag als Winkel',
          tag_cardinal: 'Aus OSM-Tag als Himmelsrichtung',
        },
      },
      description: 'Beschreibung',
      mapillary: {
        name: 'Straßenfotos (Mapillary)',
        type: 'html',
        html: {
          tag: 'a',
          innerHTML: 'Mapillary',
          properties: {
            href: 'https://www.mapillary.com/app/?pKey=%value%&focus=photo&z=15',
            target: '_blank',
          },
        },
      },
      'osm_traffic_sign:direction': 'OSM `traffic_sign:direction`',
      'osm_traffic_sign:forward': 'OSM `traffic_sign:forward`',
      'osm_traffic_sign:backward': 'OSM `traffic_sign:backward`',
      'osm_traffic_sign:both': 'OSM `traffic_sign:both`',
      osm_direction: 'OSM `direction`',
    },
  },
} as const satisfies Partial<Record<string, TopicDocMasterportalGfiConfig>>

export default data
